;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="c195719f-bd47-433c-ae09-9b591d5d6230",e._sentryDebugIdIdentifier="sentry-dbid-c195719f-bd47-433c-ae09-9b591d5d6230")}catch(e){}}();
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[939],{

/***/ 609:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pricing",
      function () {
        return __webpack_require__(652);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Yr": function() { return /* binding */ GApageView; },
/* harmony export */   "_k": function() { return /* binding */ initGA; },
/* harmony export */   "kC": function() { return /* binding */ linkedin_partner_id; }
/* harmony export */ });
/* unused harmony exports GAtiming, default */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_document__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6859);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_ga__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(542);





var initGA = function() {
    react_ga__WEBPACK_IMPORTED_MODULE_4__/* ["default"].initialize */ .ZP.initialize("174948987");
// put your tracking id here // put your tracking id here
};
var GApageView = function(page) {
    react_ga__WEBPACK_IMPORTED_MODULE_4__/* ["default"].pageview */ .ZP.pageview(page);
};
var linkedin_partner_id = "2306106";
var GAtiming = function(categoryName, variableName, valueNum) {
    ReactGA.timing({
        category: categoryName,
        variable: variableName,
        value: valueNum
    });
};
function Document() {
    return /*#__PURE__*/ _jsxs(Html, {
        lang: "en",
        children: [
            /*#__PURE__*/ _jsx(Head, {
                children: /*#__PURE__*/ _jsx("link", {
                    rel: "icon",
                    href: "/images/logo.png"
                })
            }),
            /*#__PURE__*/ _jsxs("body", {
                children: [
                    /*#__PURE__*/ _jsx(Main, {}),
                    /*#__PURE__*/ _jsx(NextScript, {}),
                    /*#__PURE__*/ _jsx(Script, {
                        id: "hotjar",
                        children: "(function(h,o,t,j,a,r){\n        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};\n        h._hjSettings={hjid:2953759,hjsv:6};\n        a=o.getElementsByTagName('head')[0];\n        r=o.createElement('script');r.async=1;\n        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;\n        a.appendChild(r);\n    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');"
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 652:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CoimexIcon": function() { return /* binding */ CoimexIcon; },
  "SvgGroup": function() { return /* binding */ SvgGroup; },
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Pricing; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(6305);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@mui/lab/TabContext/TabContext.js
var TabContext = __webpack_require__(5670);
// EXTERNAL MODULE: ./node_modules/@mui/lab/TabPanel/TabPanel.js + 2 modules
var TabPanel = __webpack_require__(7525);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 5 modules
var esm = __webpack_require__(7871);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 3 modules
var Button = __webpack_require__(9417);
;// CONCATENATED MODULE: ./src/UI/components/CoimexButton/CoimexButton.js

// @flow



var CoimexButton = function(props) {
    return(// <LoadingButton
    //   {...props}
    //   loading={props.loading}
    //   className={`containerBtn ${props.className}`}
    //   variant="contained"
    // >
    //   <p className="text">{props.children}</p>
    // </LoadingButton>
    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
        onClick: props.onClick,
        className: "bg-fontColorB capitalize w-[99px] h-[42px] rounded-full text-white font-montserrat text-base",
        children: props.children
    }));
};

;// CONCATENATED MODULE: ./src/UI/components/TabPlane/CardPlane.js

// @flow


var CardPlane = function(props) {
    var ref = (0,esm/* useTranslation */.$G)(), t = ref.t, i18n = ref.i18n;
    var item = props.item;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-whiteLatic mt-3 md:w-full w-11/12 mx-auto cursor-pointer h-40 rounded-lg pt-4 px-4 select-none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                className: "text-Primary6d text-base font-Montserrat font-bold",
                children: item === null || item === void 0 ? void 0 : item.type
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "text text-base text-PrimaryA7",
                children: [
                    item === null || item === void 0 ? void 0 : item.quota.posts.count,
                    "  ",
                    t("Price.3")
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "text text-base text-PrimaryA7",
                children: [
                    item === null || item === void 0 ? void 0 : item.quota.categories,
                    "  ",
                    t("Price.4")
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row-reverse mt-4 items-center justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CoimexButton, {
                        className: "w-24",
                        onClick: function() {
                            return props.onClick(item);
                        },
                        children: t("Price.2")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "text text-base text-Primary33",
                        children: [
                            "$",
                            item === null || item === void 0 ? void 0 : item.price
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(1120);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./src/UI/components/TabPlane/TabPlane.js


// @flow







var useStyles = (0,makeStyles/* default */.Z)({
    tabPanelRoot: {
        padding: 0,
        width: "100%",
        margin: 0
    },
    container: {
        display: "flex",
        height: "100%",
        width: "100%"
    }
});
var TabPlane = function(props) {
    var router = (0,next_router.useRouter)();
    var classes = useStyles();
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState("1"), 2), value = ref[0], setValue = ref[1];
    var ref1 = (0,esm/* useTranslation */.$G)(), t = ref1.t, i18n = ref1.i18n;
    var handleChange = function(newValue) {
        setValue(newValue);
    };
    var handlePay = function(e) {
        if (e.type === "Freemium") {
            navigate("/");
        } else {
            navigate("/Pay/".concat(e.id));
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabContext/* default */.ZP, {
        value: value,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex md:w-full w-11/12 h-9 items-center select-none cursor-pointer justify-around border rounded-md border-PrimaryC6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        tabIndex: 0,
                        role: "button",
                        onKeyDown: function() {
                            return handleChange("1");
                        },
                        onClick: function() {
                            return handleChange("1");
                        },
                        className: "w-2/4 text-fontColor text text-base font-semibold flex justify-center items-center rounded-l-md   cursor-pointer  h-9 ".concat(value === "1" && "bg-PrimaryC6"),
                        children: t("Price.5")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        tabIndex: -1,
                        role: "button",
                        onKeyDown: function() {
                            return handleChange("2");
                        },
                        onClick: function() {
                            return handleChange("2");
                        },
                        className: "w-2/4 text-fontColor flex text text-base font-semibold justify-center items-center rounded-r-md  cursor-pointer h-9 ".concat(value === "2" && "bg-PrimaryC6"),
                        children: t("Price.6")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabPanel/* default */.Z, {
                className: "w-full p-0 mt-5 mb-4 ",
                value: "1",
                children: props.data.map(function(item, key) {
                    return item.duration.type === "Annually" && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardPlane, {
                        item: item,
                        onClick: function(e) {
                            return router.push("https://app.coimex.co/#/auth/register/exporter/".concat(e.id));
                        }
                    }, key);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabPanel/* default */.Z, {
                className: "w-full p-0 mt-5 mb-4 ",
                value: "2",
                children: props.data.map(function(item, key) {
                    return item.duration.type !== "Annually" && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardPlane, {
                        item: item,
                        onClick: function(e) {
                            return router.push("https://app.coimex.co/#/auth/register/exporter/".concat(e.id));
                        }
                    }, key);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/assets/newPlansImpoter.json
var newPlansImpoter_namespaceObject = JSON.parse('{"data":[{"id":"d864bc06-e2a4-45ce-8012-a35ce66cc99e","createdAt":1672025056397,"updatedAt":1672025056397,"type":"Scale","duration":{"type":"Biannually","count":2,"unit":"Year"},"quota":{"posts":{"count":5,"every":1,"unit":"Week","days":7},"tradeGuarantee":5,"productCategory":1,"escrowSafePaymentFees":5,"promptPayAssurance":false,"expansionFund":false,"systemUsage":1,"categories":5,"messagingProductPosts":"Limitless","replyingProductPostsMessages":"Limitless","regionsAndCountries":"Limitless","instantOpportunityNotifications":true,"coiwallAccess":"FullAccess","nonMemberTrustVerification":5,"support":{"technical":true,"dealNegotiation":true,"productPost":true,"coiwall":true,"marketing":true,"strategicForeignTrade":true},"newSupport":{"matchmakingAndDealSupport":true,"nonMemberVerification":5,"opportunityAndPostSupport":true,"tradeShowMetingSupport":true,"marketingSupport":true,"strategicSupport":true}},"price":1999,"EXIMPrice":1599,"roles":["Importer"],"quotaText":{"categories":"5 Categories","posts":"5/week"}},{"id":"ab5e52e5-b723-4f98-a90a-8dee30424001","createdAt":1672025056397,"updatedAt":1672025056397,"type":"Growth","duration":{"type":"Biannually","count":2,"unit":"Year"},"quota":{"posts":{"count":2,"every":1,"unit":"Week","days":7},"tradeGuarantee":3,"productCategory":3,"escrowSafePaymentFees":3,"promptPayAssurance":false,"expansionFund":false,"systemUsage":1,"categories":3,"messagingProductPosts":"Limitless","replyingProductPostsMessages":"Limitless","regionsAndCountries":"Limitless","instantOpportunityNotifications":true,"coiwallAccess":"FullAccess","nonMemberTrustVerification":3,"support":{"technical":true,"dealNegotiation":true,"productPost":true,"coiwall":false,"marketing":false,"strategicForeignTrade":false},"newSupport":{"matchmakingAndDealSupport":true,"nonMemberVerification":3,"opportunityAndPostSupport":true,"tradeShowMetingSupport":true,"marketingSupport":false,"strategicSupport":false}},"price":799,"EXIMPrice":639,"roles":["Importer"],"quotaText":{"categories":"3 Categories","posts":"2/week"}},{"id":"2bde67df-1d53-4380-8f56-c2b776ca4680","createdAt":1672025056397,"updatedAt":1672025056397,"type":"Starter","duration":{"type":"Biannually","count":2,"unit":"Year"},"quota":{"posts":{"count":1,"every":1,"unit":"Week","days":7},"tradeGuarantee":1,"productCategory":1,"escrowSafePaymentFees":1,"promptPayAssurance":false,"expansionFund":true,"systemUsage":1,"categories":1,"messagingProductPosts":"Limitless","replyingProductPostsMessages":"Limitless","regionsAndCountries":"Limitless","instantOpportunityNotifications":true,"coiwallAccess":"FullAccess","nonMemberTrustVerification":1,"support":{"technical":true,"dealNegotiation":true,"productPost":false,"coiwall":false,"marketing":false,"strategicForeignTrade":false},"newSupport":{"matchmakingAndDealSupport":true,"nonMemberVerification":1,"opportunityAndPostSupport":false,"tradeShowMetingSupport":false,"marketingSupport":false,"strategicSupport":false}},"price":399,"EXIMPrice":319,"roles":["Importer"],"quotaText":{"categories":"1 Category","posts":"1/week"}},{"id":"3d1a266c-2a4e-4c44-b6b5-449bdf022e96","createdAt":1672025056397,"updatedAt":1672025056397,"type":"Freemium","duration":{"type":"Biannually","count":2,"unit":"Year"},"quota":{"posts":{"count":1,"every":1,"unit":"Month","days":30},"tradeGuarantee":1,"productCategory":1,"escrowSafePaymentFees":1,"promptPayAssurance":false,"expansionFund":true,"systemUsage":1,"categories":1,"messagingProductPosts":"Limitless","replyingProductPostsMessages":1,"regionsAndCountries":"Limitless","instantOpportunityNotifications":true,"coiwallAccess":"ReadOnly","nonMemberTrustVerification":0,"support":{"technical":true,"dealNegotiation":false,"productPost":false,"coiwall":false,"marketing":false,"strategicForeignTrade":false},"newSupport":{"matchmakingAndDealSupport":true,"nonMemberVerification":1,"opportunityAndPostSupport":false,"tradeShowMetingSupport":false,"marketingSupport":false,"strategicSupport":false}},"price":0,"EXIMPrice":0,"roles":["Importer"],"quotaText":{"categories":"1 Category","posts":"1/month"}},{"id":"f2d02358-e0af-410f-abf0-7af0d6b01531","createdAt":1672025056397,"updatedAt":1672025056397,"type":"Scale","duration":{"type":"Annually","count":1,"unit":"Year"},"commonTag":"Best for","bestFor":"Large enterprises","description":"needing premium support","description2":"needing","quota":{"posts":{"count":5,"every":1,"unit":"Week","days":7},"tradeGuarantee":5,"productCategory":5,"escrowSafePaymentFees":5,"promptPayAssurance":false,"expansionFund":false,"systemUsage":1,"categories":5,"messagingProductPosts":"Limitless","replyingProductPostsMessages":"Limitless","regionsAndCountries":"Limitless","instantOpportunityNotifications":true,"coiwallAccess":"FullAccess","nonMemberTrustVerification":5,"support":{"technical":true,"dealNegotiation":true,"productPost":true,"coiwall":true,"marketing":true,"strategicForeignTrade":true},"newSupport":{"matchmakingAndDealSupport":true,"nonMemberVerification":5,"opportunityAndPostSupport":true,"tradeShowMetingSupport":true,"marketingSupport":true,"strategicSupport":true}},"price":1999,"EXIMPrice":1599,"roles":["Importer"],"quotaText":{"categories":"5 Categories","posts":"5/week"}},{"id":"1f0be916-93ce-4479-a3e7-235244f91a4d","createdAt":1672025056397,"updatedAt":1672025056397,"type":"Growth","duration":{"type":"Annually","count":1,"unit":"Year"},"commonTag":"Best for","bestFor":"Growing businesses","description":" expanding their reach","description2":" ","quota":{"posts":{"count":2,"every":1,"unit":"Week","days":7},"tradeGuarantee":3,"productCategory":3,"escrowSafePaymentFees":3,"promptPayAssurance":false,"expansionFund":false,"systemUsage":1,"categories":3,"messagingProductPosts":"Limitless","replyingProductPostsMessages":"Limitless","regionsAndCountries":"Limitless","instantOpportunityNotifications":true,"coiwallAccess":"FullAccess","nonMemberTrustVerification":3,"support":{"technical":true,"dealNegotiation":true,"productPost":true,"coiwall":false,"marketing":false,"strategicForeignTrade":false},"newSupport":{"matchmakingAndDealSupport":true,"nonMemberVerification":3,"opportunityAndPostSupport":true,"tradeShowMetingSupport":true,"marketingSupport":false,"strategicSupport":false}},"price":799,"EXIMPrice":639,"roles":["Importer"],"quotaText":{"categories":"3 Categories","posts":"2/week"}},{"id":"bf1dfc97-71bc-4afe-b866-44e7d9bbb35a","createdAt":1672025056397,"updatedAt":1672025056397,"type":"Starter","duration":{"type":"Annually","count":1,"unit":"Year"},"commonTag":"Best for","bestFor":"small businesses","description":"testing the platform","description2":"","quota":{"posts":{"count":1,"every":1,"unit":"Week","days":7},"tradeGuarantee":1,"productCategory":1,"escrowSafePaymentFees":1,"promptPayAssurance":false,"expansionFund":true,"systemUsage":1,"categories":1,"messagingProductPosts":"Limitless","replyingProductPostsMessages":"Limitless","regionsAndCountries":"Limitless","instantOpportunityNotifications":true,"coiwallAccess":"FullAccess","nonMemberTrustVerification":1,"support":{"technical":true,"dealNegotiation":true,"productPost":false,"coiwall":false,"marketing":false,"strategicForeignTrade":false},"newSupport":{"matchmakingAndDealSupport":true,"nonMemberVerification":1,"opportunityAndPostSupport":false,"tradeShowMetingSupport":false,"marketingSupport":false,"strategicSupport":false}},"price":399,"EXIMPrice":319,"roles":["Importer"],"quotaText":{"categories":"1 Category","posts":"1/week"}},{"id":"7d4d4bbe-2234-463c-87d3-b4d25d2c75ab","createdAt":1672025056397,"updatedAt":1672025056397,"type":"Freemium","duration":{"type":"Annually","count":1,"unit":"Year"},"commonTag":"Best for","bestFor":"small businesses","description":"testing the platform","description2":"","quota":{"posts":{"count":1,"every":1,"unit":"Month","days":30},"tradeGuarantee":1,"productCategory":1,"escrowSafePaymentFees":1,"promptPayAssurance":false,"expansionFund":true,"systemUsage":1,"categories":1,"messagingProductPosts":"Limitless","replyingProductPostsMessages":1,"regionsAndCountries":"Limitless","instantOpportunityNotifications":true,"coiwallAccess":"ReadOnly","nonMemberTrustVerification":0,"support":{"technical":true,"dealNegotiation":false,"productPost":false,"coiwall":false,"marketing":false,"strategicForeignTrade":false},"newSupport":{"matchmakingAndDealSupport":true,"nonMemberVerification":1,"opportunityAndPostSupport":false,"tradeShowMetingSupport":false,"marketingSupport":false,"strategicSupport":false}},"price":0,"EXIMPrice":0,"roles":["Importer"],"quotaText":{"categories":"1 Category","posts":"1/month"}}]}');
;// CONCATENATED MODULE: ./src/assets/plansExport.json
var plansExport_namespaceObject = {};
;// CONCATENATED MODULE: ./src/assets/newPlansBoth.json
var newPlansBoth_namespaceObject = JSON.parse('{"data":[{"id":"8cecab37-a892-48c9-af69-118e172bdbbc","createdAt":1672025056397,"updatedAt":1672025056397,"type":"Scale","duration":{"type":"Biannually","count":2,"unit":"Year"},"commonTag":"Best for","bestFor":"Large enterprises","description":"needing premium support","description2":"needing","quota":{"posts":{"count":5,"every":1,"unit":"Week","days":7},"tradeGuarantee":5,"productCategory":5,"escrowSafePaymentFees":5,"promptPayAssurance":true,"systemUsage":5,"categories":5,"messagingProductPosts":"Limitless","replyingProductPostsMessages":"Limitless","regionsAndCountries":"Limitless","instantOpportunityNotifications":true,"coiwallAccess":"FullAccess","nonMemberTrustVerification":5,"customerAcquisitionGuarantee":true,"support":{"technical":true,"dealNegotiation":true,"productPost":true,"coiwall":true,"marketing":true,"strategicForeignTrade":true},"newSupport":{"matchmakingAndDealSupport":true,"nonMemberVerification":5,"opportunityAndPostSupport":true,"tradeShowMetingSupport":true,"marketingSupport":true,"strategicSupport":true}},"price":1999,"EXIMPrice":1599,"roles":["Importer","Exporter"],"quotaText":{"categories":"5 Categories","posts":"5/week"}},{"id":"6d82c81d-5dae-4f24-aa79-68dfb48a14fc","createdAt":1672025056397,"updatedAt":1672025056397,"type":"Growth","duration":{"type":"Biannually","count":2,"unit":"Year"},"commonTag":"Best for","bestFor":"Growing businesses","description":"expanding their reach","quota":{"posts":{"count":2,"every":1,"unit":"Week","days":7},"tradeGuarantee":3,"productCategory":3,"escrowSafePaymentFees":3,"promptPayAssurance":true,"systemUsage":2,"categories":3,"messagingProductPosts":"Limitless","replyingProductPostsMessages":"Limitless","regionsAndCountries":"Limitless","instantOpportunityNotifications":true,"coiwallAccess":"FullAccess","nonMemberTrustVerification":3,"customerAcquisitionGuarantee":true,"support":{"technical":true,"dealNegotiation":true,"productPost":true,"coiwall":false,"marketing":false,"strategicForeignTrade":false},"newSupport":{"matchmakingAndDealSupport":true,"nonMemberVerification":3,"opportunityAndPostSupport":true,"tradeShowMetingSupport":true,"marketingSupport":false,"strategicSupport":false}},"price":799,"EXIMPrice":639,"roles":["Importer","Exporter"],"quotaText":{"categories":"3 Categories","posts":"2/week"}},{"id":"72127eca-6dcc-471b-a31f-a5397cf658b6","createdAt":1672025056397,"updatedAt":1672025056397,"type":"Starter","duration":{"type":"Biannually","count":2,"unit":"Year"},"commonTag":"Best for","bestFor":"Small businesses","description":"testing the platform","quota":{"posts":{"count":1,"every":1,"unit":"Week","days":7},"tradeGuarantee":1,"productCategory":1,"escrowSafePaymentFees":1,"promptPayAssurance":false,"systemUsage":1,"categories":1,"messagingProductPosts":"Limitless","replyingProductPostsMessages":"Limitless","regionsAndCountries":"Limitless","instantOpportunityNotifications":true,"coiwallAccess":"FullAccess","nonMemberTrustVerification":1,"customerAcquisitionGuarantee":true,"support":{"technical":true,"dealNegotiation":true,"productPost":false,"coiwall":false,"marketing":false,"strategicForeignTrade":false},"newSupport":{"matchmakingAndDealSupport":true,"nonMemberVerification":1,"opportunityAndPostSupport":false,"tradeShowMetingSupport":false,"marketingSupport":false,"strategicSupport":false}},"price":399,"EXIMPrice":319,"roles":["Importer","Exporter"],"quotaText":{"categories":"1 Category","posts":"1/week"}},{"id":"c29d72ba-09ea-4831-8383-333474125c32","createdAt":1672025056397,"updatedAt":1672025056397,"type":"Scale","duration":{"type":"Annually","count":1,"unit":"Year"},"commonTag":"Best for","bestFor":"Large enterprises","description":"premium support","description2":"needing","quota":{"posts":{"count":5,"every":1,"unit":"Week","days":7},"tradeGuarantee":5,"productCategory":5,"escrowSafePaymentFees":5,"promptPayAssurance":true,"systemUsage":5,"categories":5,"messagingProductPosts":"Limitless","replyingProductPostsMessages":"Limitless","regionsAndCountries":"Limitless","instantOpportunityNotifications":true,"coiwallAccess":"FullAccess","nonMemberTrustVerification":5,"customerAcquisitionGuarantee":true,"support":{"technical":true,"dealNegotiation":true,"productPost":true,"coiwall":true,"marketing":true,"strategicForeignTrade":true},"newSupport":{"matchmakingAndDealSupport":true,"nonMemberVerification":5,"opportunityAndPostSupport":true,"tradeShowMetingSupport":true,"marketingSupport":true,"strategicSupport":true}},"price":1999,"EXIMPrice":1599,"roles":["Importer","Exporter"],"quotaText":{"categories":"5 Categories","posts":"5/week"}},{"id":"9d0e3073-0b1d-4be7-ab85-12be0b4bbaf8","createdAt":1672025056397,"updatedAt":1672025056397,"type":"Growth","duration":{"type":"Annually","count":1,"unit":"Year"},"commonTag":"Best for","bestFor":"Growing businesses","description":"expanding their reach","description2":"","quota":{"posts":{"count":2,"every":1,"unit":"Week","days":7},"tradeGuarantee":3,"productCategory":3,"escrowSafePaymentFees":3,"promptPayAssurance":true,"systemUsage":2,"categories":3,"messagingProductPosts":"Limitless","replyingProductPostsMessages":"Limitless","regionsAndCountries":"Limitless","instantOpportunityNotifications":true,"coiwallAccess":"FullAccess","nonMemberTrustVerification":3,"customerAcquisitionGuarantee":true,"support":{"technical":true,"dealNegotiation":true,"productPost":true,"coiwall":false,"marketing":false,"strategicForeignTrade":false},"newSupport":{"matchmakingAndDealSupport":true,"nonMemberVerification":3,"opportunityAndPostSupport":true,"tradeShowMetingSupport":true,"marketingSupport":false,"strategicSupport":false}},"price":799,"EXIMPrice":639,"roles":["Importer","Exporter"],"quotaText":{"categories":"3 Categories","posts":"2/week"}},{"id":"e3d995ac-0a54-4eeb-939c-15908aa2b573","createdAt":1672025056397,"updatedAt":1672025056397,"type":"Starter","duration":{"type":"Annually","count":1,"unit":"Year"},"commonTag":"Best for","bestFor":"Small Businesses","description":" testing the platform","description2":"","quota":{"posts":{"count":1,"every":1,"unit":"Week","days":7},"tradeGuarantee":1,"productCategory":1,"escrowSafePaymentFees":1,"promptPayAssurance":false,"systemUsage":1,"categories":1,"messagingProductPosts":"Limitless","replyingProductPostsMessages":"Limitless","regionsAndCountries":"Limitless","instantOpportunityNotifications":true,"coiwallAccess":"FullAccess","nonMemberTrustVerification":1,"customerAcquisitionGuarantee":true,"support":{"technical":true,"dealNegotiation":true,"productPost":false,"coiwall":false,"marketing":false,"strategicForeignTrade":false},"newSupport":{"matchmakingAndDealSupport":true,"nonMemberVerification":1,"opportunityAndPostSupport":false,"tradeShowMetingSupport":false,"marketingSupport":false,"strategicSupport":false}},"price":399,"EXIMPrice":319,"roles":["Importer","Exporter"],"quotaText":{"categories":"1 Category","posts":"1/week"}}]}');
;// CONCATENATED MODULE: ./src/assets/newPlansExport.json
var newPlansExport_namespaceObject = JSON.parse('{"data":[{"id":"16766965-49d9-4145-b25d-46cea03588ce","createdAt":1672025056397,"updatedAt":1672025056397,"type":"Scale","duration":{"type":"Biannually","count":2,"unit":"Year"},"commonTag":"Best for","bestFor":"Large enterprises","description":"needing premium support","description2":"needing","quota":{"posts":{"count":5,"every":1,"unit":"Week","days":7},"tradeGuarantee":5,"productCategory":5,"escrowSafePaymentFees":5,"promptPayAssurance":true,"systemUsage":5,"categories":5,"messagingProductPosts":"Limitless","replyingProductPostsMessages":"Limitless","regionsAndCountries":"Limitless","instantOpportunityNotifications":true,"coiwallAccess":"FullAccess","nonMemberTrustVerification":5,"customerAcquisitionGuarantee":true,"support":{"technical":true,"dealNegotiation":true,"productPost":true,"coiwall":true,"marketing":true,"strategicForeignTrade":true},"newSupport":{"matchmakingAndDealSupport":true,"nonMemberVerification":5,"opportunityAndPostSupport":true,"tradeShowMetingSupport":true,"marketingSupport":true,"strategicSupport":true}},"price":1999,"EXIMPrice":1599,"roles":["Exporter"],"quotaText":{"categories":"5 Categories","posts":"5/week"}},{"id":"5425864a-50b6-41a6-89b5-af60059cb02b","createdAt":1672025056397,"updatedAt":1672025056397,"type":"Growth","duration":{"type":"Biannually","count":2,"unit":"Year"},"commonTag":"Best for","bestFor":"Growing businesses","description":"expanding their reach","description2":"","quota":{"posts":{"count":2,"every":1,"unit":"Week","days":7},"tradeGuarantee":3,"productCategory":3,"escrowSafePaymentFees":3,"promptPayAssurance":true,"systemUsage":2,"categories":3,"messagingProductPosts":"Limitless","replyingProductPostsMessages":"Limitless","regionsAndCountries":"Limitless","instantOpportunityNotifications":true,"coiwallAccess":"FullAccess","nonMemberTrustVerification":3,"customerAcquisitionGuarantee":true,"support":{"technical":true,"dealNegotiation":true,"productPost":true,"coiwall":false,"marketing":false,"strategicForeignTrade":false},"newSupport":{"matchmakingAndDealSupport":true,"nonMemberVerification":3,"opportunityAndPostSupport":true,"tradeShowMetingSupport":true,"marketingSupport":false,"strategicSupport":false}},"price":799,"EXIMPrice":639,"roles":["Exporter"],"quotaText":{"categories":"3 Categories","posts":"2/week"}},{"id":"ce8facbc-f61f-4145-8661-06ea496ad01a","createdAt":1672025056397,"updatedAt":1672025056397,"type":"Starter","duration":{"type":"Biannually","count":2,"unit":"Year"},"commonTag":"Best for","bestFor":"small businesses","description":"testing the platform","description2":"","quota":{"posts":{"count":1,"every":1,"unit":"Week","days":7},"tradeGuarantee":1,"productCategory":1,"escrowSafePaymentFees":1,"promptPayAssurance":false,"systemUsage":1,"categories":1,"messagingProductPosts":"Limitless","replyingProductPostsMessages":"Limitless","regionsAndCountries":"Limitless","instantOpportunityNotifications":true,"coiwallAccess":"FullAccess","nonMemberTrustVerification":1,"customerAcquisitionGuarantee":true,"support":{"technical":true,"dealNegotiation":true,"productPost":false,"coiwall":false,"marketing":false,"strategicForeignTrade":false},"newSupport":{"matchmakingAndDealSupport":true,"nonMemberVerification":1,"opportunityAndPostSupport":false,"tradeShowMetingSupport":false,"marketingSupport":false,"strategicSupport":false}},"price":399,"EXIMPrice":319,"roles":["Exporter"],"quotaText":{"categories":"1 Category","posts":"1/week"}},{"id":"d928f16e-dbfa-4568-a2b4-f942943af632","createdAt":1672025056397,"updatedAt":1672025056397,"type":"Scale","duration":{"type":"Annually","count":1,"unit":"Year"},"commonTag":"Best for","bestFor":"Large enterprises","description":"needing premium support","description2":"needing","quota":{"posts":{"count":5,"every":1,"unit":"Week","days":7},"tradeGuarantee":5,"productCategory":5,"escrowSafePaymentFees":5,"promptPayAssurance":true,"systemUsage":5,"categories":5,"messagingProductPosts":"Limitless","replyingProductPostsMessages":"Limitless","regionsAndCountries":"Limitless","instantOpportunityNotifications":true,"coiwallAccess":"FullAccess","nonMemberTrustVerification":5,"customerAcquisitionGuarantee":true,"support":{"technical":true,"dealNegotiation":true,"productPost":true,"coiwall":true,"marketing":true,"strategicForeignTrade":true},"newSupport":{"matchmakingAndDealSupport":true,"nonMemberVerification":5,"opportunityAndPostSupport":true,"tradeShowMetingSupport":true,"marketingSupport":true,"strategicSupport":true}},"price":1999,"EXIMPrice":1599,"roles":["Exporter"],"quotaText":{"categories":"5 Categories","posts":"5/week"}},{"id":"757148ed-c7e7-4f22-b7e7-8b1f72268ed1","createdAt":1672025056397,"updatedAt":1672025056397,"type":"Growth","duration":{"type":"Annually","count":1,"unit":"Year"},"commonTag":"Best for","bestFor":"Growing businesses","description":"expanding their reach","description2":"","quota":{"posts":{"count":2,"every":1,"unit":"Week","days":7},"tradeGuarantee":3,"productCategory":3,"escrowSafePaymentFees":3,"promptPayAssurance":true,"systemUsage":2,"categories":3,"messagingProductPosts":"Limitless","replyingProductPostsMessages":"Limitless","regionsAndCountries":"Limitless","instantOpportunityNotifications":true,"coiwallAccess":"FullAccess","nonMemberTrustVerification":3,"customerAcquisitionGuarantee":true,"support":{"technical":true,"dealNegotiation":true,"productPost":true,"coiwall":false,"marketing":false,"strategicForeignTrade":false},"newSupport":{"matchmakingAndDealSupport":true,"nonMemberVerification":3,"opportunityAndPostSupport":true,"tradeShowMetingSupport":true,"marketingSupport":false,"strategicSupport":false}},"price":799,"EXIMPrice":639,"roles":["Exporter"],"quotaText":{"categories":"3 Categories","posts":"2/week"}},{"id":"b060cc84-f8d9-49eb-a7b7-04c5b36cc088","createdAt":1672025056397,"updatedAt":1672025056397,"type":"Starter","duration":{"type":"Annually","count":1,"unit":"Year"},"commonTag":"Best for","bestFor":"small businesses","description":"testing the platform","description2":"","quota":{"posts":{"count":1,"every":1,"unit":"Week","days":7},"tradeGuarantee":1,"productCategory":1,"escrowSafePaymentFees":1,"promptPayAssurance":false,"systemUsage":1,"categories":1,"messagingProductPosts":"Limitless","replyingProductPostsMessages":"Limitless","regionsAndCountries":"Limitless","instantOpportunityNotifications":true,"coiwallAccess":"FullAccess","nonMemberTrustVerification":1,"customerAcquisitionGuarantee":true,"support":{"technical":true,"dealNegotiation":true,"productPost":false,"coiwall":false,"marketing":false,"strategicForeignTrade":false},"newSupport":{"matchmakingAndDealSupport":true,"nonMemberVerification":1,"opportunityAndPostSupport":false,"tradeShowMetingSupport":false,"marketingSupport":false,"strategicSupport":false}},"price":399,"EXIMPrice":319,"roles":["Exporter"],"quotaText":{"categories":"1 Category","posts":"1/week"}}]}');
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/Divider.js + 1 modules
var Divider = __webpack_require__(1519);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./node_modules/@mui/material/Table/Table.js + 1 modules
var Table = __webpack_require__(7906);
// EXTERNAL MODULE: ./node_modules/@mui/material/TableBody/TableBody.js + 1 modules
var TableBody = __webpack_require__(295);
// EXTERNAL MODULE: ./node_modules/@mui/material/TableCell/TableCell.js + 1 modules
var TableCell = __webpack_require__(3252);
// EXTERNAL MODULE: ./node_modules/@mui/material/TableContainer/TableContainer.js + 1 modules
var TableContainer = __webpack_require__(2882);
// EXTERNAL MODULE: ./node_modules/@mui/material/TableHead/TableHead.js + 1 modules
var TableHead = __webpack_require__(3184);
// EXTERNAL MODULE: ./node_modules/@mui/material/TableRow/TableRow.js + 1 modules
var TableRow = __webpack_require__(3816);
;// CONCATENATED MODULE: ./src/UI/components/Card/Button.js



var Button_CoimexButton = function(props) {
    return(// <LoadingButton
    //   {...props}
    //   loading={props.loading}
    //   className={`containerBtn ${props.className}`}
    //   variant="contained"
    // >
    //   <p className="text">{props.children}</p>
    // </LoadingButton>
    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
        onClick: props.onClick,
        className: "bg-fontColorB capitalize h-[42px] rounded-full text-[#FFFBFE] font-montserrat font-extrabold text-base",
        children: props.children
    }));
};

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 2 modules
var withStyles = __webpack_require__(4806);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tooltip/Tooltip.js + 58 modules
var Tooltip = __webpack_require__(3365);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tooltip/tooltipClasses.js
var tooltipClasses = __webpack_require__(8999);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(1496);
;// CONCATENATED MODULE: ./src/UI/components/Table/NewPricingTable.js





















function createData(name, param, ali) {
    var _param = (0,_sliced_to_array/* default */.Z)(param, 4), calories = _param[0], fat = _param[1], carbs = _param[2], protein = _param[3];
    return {
        name: name,
        calories: calories,
        fat: fat,
        carbs: carbs,
        protein: protein,
        ali: ali
    };
}
var NewPricingTable_useStyles = (0,makeStyles/* default */.Z)({
    table: {
        minWidth: 650
    },
    tableRow: {
        height: 20,
        paddingLeft: "32px",
        paddingRight: "32px"
    },
    tableCell: {
        padding: "0px 10px"
    }
});
var StyledTableRow = (0,withStyles/* default */.Z)(function(theme) {
    return {
        root: {
            height: 20
        }
    };
})(TableRow/* default */.Z);
function CoimexNewTable(props) {
    var handleType = function handleType() {
        switch(type){
            case "importer":
                return rowsNewImporter;
            case "exporter":
                return rowsNewExporter;
            default:
                return rowsNewBoth;
        }
    };
    var handleSupport = function handleSupport() {
        switch(type){
            case "importer":
                return SupportDef;
            case "exporter":
                return Supportexport;
            default:
                return NewSupportBoth;
        }
    };
    var ref = (0,esm/* useTranslation */.$G)(), t = ref.t, i18n = ref.i18n;
    var router = (0,next_router.useRouter)();
    var classes = NewPricingTable_useStyles();
    var ref1 = (0,react.useState)([]), rowsData = ref1[0], setRowsData = ref1[1];
    var type = router.query.package;
    var que = type === "importer" ? t("Price.10") : t("Price.11");
    var offer = type === "importer" ? t("Price.24") : t("Price.8");
    var productSupport = function(data) {
        return props.data.map(function(item, key) {
            return item.duration.type === props.value ? item === null || item === void 0 ? void 0 : item.quota.newSupport[data] : null;
        });
    };
    console.log("Props", props);
    var product = function(data) {
        return props.data.map(function(item, key) {
            return item.duration.type === props.value ? data === "posts" ? item === null || item === void 0 ? void 0 : item.quotaText.posts : item === null || item === void 0 ? void 0 : item.quota[data] : null;
        });
    };
    var rowsExporter = [
        createData(t("Price.9"), product("categories").filter(function(item) {
            return item;
        }), t("Price.36")),
        createData(offer, product("posts").filter(function(item) {
            return item;
        }), t("Price.37")),
        //
        createData(que, product("replyingProductPostsMessages").filter(function(item) {
            return item;
        }), t("Price.38")),
        createData(t("Price.12"), product("regionsAndCountries").filter(function(item) {
            return item;
        }), t("Price.39")),
        createData(t("Price.13"), product("instantOpportunityNotifications").filter(function(item) {
            return item;
        }), t("Price.40")),
        createData(t("Price.14"), product("coiwallAccess").filter(function(item) {
            return item;
        }), t("Price.41")),
        createData(t("Price.15"), product("nonMemberTrustVerification"), t("Price.42")), 
    ];
    var rowsImporter = [
        createData(t("Price.9"), product("categories").filter(function(item) {
            return item;
        }), t("Price.28")),
        createData(offer, product("posts").filter(function(item) {
            return item;
        }), t("Price.29")),
        //
        createData(t("Price.26"), product("messagingProductPosts").filter(function(item) {
            return item;
        }), t("Price.30")),
        createData(que, product("replyingProductPostsMessages").filter(function(item) {
            return item;
        }), t("Price.31")),
        createData(t("Price.12"), product("regionsAndCountries").filter(function(item) {
            return item;
        }), t("Price.32")),
        createData(t("Price.13"), product("instantOpportunityNotifications").filter(function(item) {
            return item;
        }), t("Price.33")),
        createData(t("Price.14"), product("coiwallAccess").filter(function(item) {
            return item;
        }), t("Price.34")),
        createData(t("Price.15"), product("nonMemberTrustVerification"), t("Price.35")), 
    ];
    var rowsBoth = [
        createData(t("Price.9"), product("categories").filter(function(item) {
            return item;
        }), t("Price.43")),
        createData(t("Price.26"), product("messagingProductPosts").filter(function(item) {
            return item;
        }), t("Price.46")),
        createData(t("Price.24"), product("posts").filter(function(item) {
            return item;
        }), t("Price.45")),
        createData(t("Price.8"), product("posts").filter(function(item) {
            return item;
        }), t("Price.43")),
        createData(t("Price.10"), product("replyingProductPostsMessages").filter(function(item) {
            return item;
        }), t("Price.47")),
        createData(t("Price.11"), product("replyingProductPostsMessages").filter(function(item) {
            return item;
        }), t("Price.44")),
        createData(t("Price.12"), product("regionsAndCountries").filter(function(item) {
            return item;
        }), t("Price.48")),
        createData(t("Price.13"), product("instantOpportunityNotifications").filter(function(item) {
            return item;
        }), t("Price.49")),
        createData(t("Price.14"), product("coiwallAccess").filter(function(item) {
            return item;
        }), t("Price.50")),
        createData(t("Price.15"), product("nonMemberTrustVerification").filter(function(item) {
            return item;
        }), t("Price.51")), 
    ];
    var rowsNewExporter = [
        createData(t("NewPrice.20"), product("tradeGuarantee").filter(function(item) {
            return item;
        }), t("Price.43")),
        // createData(
        //   offer,
        //   product("posts").filter((item) => item),
        //   t("Price.37")
        // ),
        createData(t("NewPrice.21"), product("productCategory").filter(function(item) {
            return item;
        }), t("Price.30")),
        // createData(
        //   que,
        //   product("replyingProductPostsMessages").filter((item) => item),
        //   t("Price.38")
        // ),
        createData(t("NewPrice.22"), product("escrowSafePaymentFees").filter(function(item) {
            return item;
        }), t("Price.32")),
        createData(t("NewPrice.23"), product("promptPayAssurance").filter(function(item) {
            return item != null;
        }), t("Price.43")),
        createData(t("NewPrice.24"), product("systemUsage").filter(function(item) {
            return item;
        }), t("Price.33")), 
    ];
    var rowsNewImporter = [
        createData(t("NewPrice.20"), product("tradeGuarantee").filter(function(item) {
            return item;
        }), t("Price.43")),
        // createData(
        //   offer,
        //   product("posts").filter((item) => item),
        //   t("Price.29")
        // ),
        createData(t("NewPrice.21"), product("productCategory").filter(function(item) {
            return item;
        }), t("Price.30")),
        // createData(
        //   que,
        //   product("replyingProductPostsMessages").filter((item) => item),
        //   t("Price.31")
        // ),
        createData(t("NewPrice.22"), product("escrowSafePaymentFees").filter(function(item) {
            return item;
        }), t("Price.32")),
        createData(t("NewPrice.24"), product("systemUsage").filter(function(item) {
            return item;
        }), t("Price.33")), 
    ];
    var rowsNewBoth = [
        createData(t("NewPrice.20"), product("tradeGuarantee").filter(function(item) {
            return item;
        }), t("Price.43")),
        createData(t("NewPrice.21"), product("productCategory").filter(function(item) {
            return item;
        }), t("Price.46")),
        createData(t("NewPrice.22"), product("escrowSafePaymentFees").filter(function(item) {
            return item;
        }), t("Price.45")),
        createData(t("NewPrice.23"), product("promptPayAssurance").filter(function(item) {
            return item !== null;
        }), t("Price.43")),
        createData(t("NewPrice.24"), product("systemUsage").filter(function(item) {
            return item;
        }), t("Price.47")), 
    ];
    var offerSupport = type === "importer" ? t("Price.25") : t("Price.18");
    var SupportDef = [
        createData(t("NewPrice.26"), productSupport("matchmakingAndDealSupport").filter(function(item) {
            return item != null;
        })),
        createData(t("NewPrice.27"), productSupport("nonMemberVerification").filter(function(item) {
            return item != null;
        })),
        createData(t("NewPrice.28"), productSupport("opportunityAndPostSupport").filter(function(item) {
            return item != null;
        })),
        createData(t("NewPrice.29"), productSupport("tradeShowMetingSupport").filter(function(item) {
            return item != null;
        })),
        createData(t("NewPrice.30"), productSupport("marketingSupport").filter(function(item) {
            return item != null;
        })),
        createData(t("NewPrice.31"), productSupport("strategicSupport").filter(function(item) {
            return item != null;
        })), 
    ];
    var Supportexport = [
        createData(t("NewPrice.26"), productSupport("matchmakingAndDealSupport").filter(function(item) {
            return item != null;
        })),
        createData(t("NewPrice.27"), productSupport("nonMemberVerification").filter(function(item) {
            return item != null;
        })),
        createData(t("NewPrice.28"), productSupport("opportunityAndPostSupport").filter(function(item) {
            return item != null;
        })),
        createData(t("NewPrice.29"), productSupport("tradeShowMetingSupport").filter(function(item) {
            return item != null;
        })),
        createData(t("NewPrice.30"), productSupport("marketingSupport").filter(function(item) {
            return item != null;
        })),
        createData(t("NewPrice.31"), productSupport("strategicSupport").filter(function(item) {
            return item != null;
        })), 
    ];
    var SupportBoth = [
        createData(t("Price.16"), productSupport("technical").filter(function(item) {
            return item != null;
        })),
        createData(t("Price.17"), productSupport("dealNegotiation").filter(function(item) {
            return item != null;
        })),
        createData(t("Price.18"), productSupport("productPost").filter(function(item) {
            return item != null;
        })),
        createData(t("Price.25"), productSupport("productPost").filter(function(item) {
            return item != null;
        })),
        createData(t("Price.19"), productSupport("coiwall").filter(function(item) {
            return item != null;
        })),
        createData(t("Price.20"), productSupport("marketing").filter(function(item) {
            return item != null;
        })),
        createData(t("Price.21"), productSupport("strategicForeignTrade").filter(function(item) {
            return item != null;
        })), 
    ];
    var NewSupportBoth = [
        createData(t("NewPrice.26"), productSupport("matchmakingAndDealSupport").filter(function(item) {
            return item != null;
        })),
        createData(t("NewPrice.27"), productSupport("nonMemberVerification").filter(function(item) {
            return item != null;
        })),
        createData(t("NewPrice.28"), productSupport("opportunityAndPostSupport").filter(function(item) {
            return item != null;
        })),
        createData(t("NewPrice.29"), productSupport("tradeShowMetingSupport").filter(function(item) {
            return item != null;
        })),
        createData(t("NewPrice.30"), productSupport("marketingSupport").filter(function(item) {
            return item != null;
        })),
        createData(t("NewPrice.31"), productSupport("strategicSupport").filter(function(item) {
            return item != null;
        })), 
    ];
    var rows = handleType();
    var Support = handleSupport();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TableContainer/* default */.Z, {
        className: "bg-textColor rounded-[16px] hidden md:block lg:block xl:block",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* default */.Z, {
            className: "w-full table-auto sm:hidden md:block lg:block xl:block",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHead/* default */.Z, {
                    className: "w-full",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                        sx: {
                            border: "none"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                className: "center text-[#38466D] !border-0 !pb-0 px-11",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    className: "text-[#38466D] !border-0 text-xl font-MontserratSemiBold",
                                    children: "Features"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                className: "text-[#38466D] !border-0 !pb-0 text-[24px] font-MontserratBold ",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    className: "text-[#38466D] text-xl font-MontserratSemiBold",
                                    children: "Details"
                                })
                            }),
                            props.data.map(function(item, key) {
                                return item.duration.type === props.value && /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    align: "center !border-0 !pb-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        className: "text-[#38466D] text-xl font-MontserratSemiBold",
                                        children: t("Price.".concat(item === null || item === void 0 ? void 0 : item.type))
                                    })
                                }, key);
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableBody/* default */.Z, {
                    className: "w-full",
                    sx: {
                        "&>tr:nth-child(2)": {
                            backgroundColor: "#EBEBF0"
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                            sx: {
                                border: "none"
                            },
                            className: "w-full ",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    className: "text-[#38466D] !border-0"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    className: "text-[#38466D] !border-0"
                                }),
                                type === "importer" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableCell/* default */.Z, {
                                    className: "text-[#38466D] !border-0 !pt-1",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-base font-semibold text-[#000] font-montserrat",
                                            children: t("NewPrice.46")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-base font-normal text-[#000] font-montserrat",
                                            children: t("NewPr@ice.49")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableCell/* default */.Z, {
                                    className: "text-[#38466D] !border-0 !pt-1",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-base font-semibold text-[#000] font-montserrat",
                                            children: t("NewPrice.46")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-base font-normal text-[#000] font-montserrat",
                                            children: t("NewPrice.49")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableCell/* default */.Z, {
                                    className: "text-[#38466D] !border-0 !pt-1",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-base font-semibold text-[#000] font-montserrat",
                                            children: t("NewPrice.47")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-base font-normal text-[#000] font-montserrat",
                                            children: t("NewPrice.50")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableCell/* default */.Z, {
                                    className: "text-[#38466D] !border-0 !pt-1",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "text-base font-semibold text-[#000] font-montserrat",
                                            children: [
                                                t("NewPrice.48"),
                                                " "
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-base font-normal text-[#000] font-montserrat",
                                            children: t("NewPrice.51")
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                            className: "bg-[#EBEBF0] w-full",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    className: "text-[#38466D] text-xl font-MontserratBold"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    className: "text-[#38466D] text-xl font-MontserratBold"
                                }),
                                props.data.filter(function(item) {
                                    return item.duration.type === props.value;
                                }).map(function(item, key) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        align: "left",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-col items-center gap-2 w-[180px] pt-1 pb-4 ",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "text-base text-[#38466D] font-MontserratBold font-bold",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            className: "text-base font-MontserratBold font-bold",
                                                            children: [
                                                                "$",
                                                                item === null || item === void 0 ? void 0 : item.price
                                                            ]
                                                        }),
                                                        " ",
                                                        props.value === "Biannually" ? t("Price.54") : " / ",
                                                        props.value === "Biannually" ? t("Price.53") : t("Price.23")
                                                    ]
                                                }),
                                                type === "importer" && item.type === "Freemium" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "text-base text-[#38466D] font-MontserratBold font-bold text-center opacity-0",
                                                            children: "Or "
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "text-base text-[#38466D] font-MontserratBold font-bold text-center opacity-0",
                                                            children: "Or "
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "flex flex-col w-[173px] items-start opacity-0",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "flex gap-1 items-center",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CoimexIcon, {}),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            className: "leading-[20px] text-base text-[#38466D] font-bold font-MontserratBold",
                                                                            children: " "
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "flex flex-col items-start w-full pl-3 opacity-0",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        className: "text-base text-[#38466D] font-bold font-MontserratBold",
                                                                        children: " "
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "text-base text-[#38466D] font-MontserratBold font-bold text-center",
                                                            children: "Or"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "flex flex-col w-[173px] items-start",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "flex gap-1 items-center",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CoimexIcon, {}),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                            className: "leading-[20px] text-base text-[#38466D] font-bold font-MontserratBold",
                                                                            children: [
                                                                                t("NewPrice.44"),
                                                                                " ",
                                                                                t("NewPrice.11")
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "flex flex-col items-start w-full pl-3",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        className: "text-base text-[#38466D] font-bold font-MontserratBold",
                                                                        children: t("NewPrice.58")
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                item.type === "Freemium" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    className: "w-full bg-[#38466D] capitalize h-[42px] rounded-full hover:bg-[#1f2a4b] text-white font-MontserratRegular font-bold text-base",
                                                    onClick: function() {
                                                        return props.onClick(item);
                                                    },
                                                    children: "Signup Now"
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    className: "w-full bg-[#38466D] capitalize h-[42px] rounded-full hover:bg-[#1f2a4b] text-white font-MontserratRegular font-bold text-base",
                                                    onClick: function() {
                                                        return props.onClick(item);
                                                    },
                                                    children: t("NewPrice.12")
                                                })
                                            ]
                                        })
                                    }, key);
                                }),
                                Array((type === "importer" ? 6 : 8) - props.data.filter(function(item) {
                                    return item.duration.type === props.value;
                                }).length).fill(null).map(function(_, i) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {}, "placeholder-".concat(i));
                                })
                            ]
                        }),
                        rows.map(function(row) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                                className: classes.tableRow,
                                style: {
                                    height: "32px"
                                },
                                sx: {
                                    "&:last-child td, &:last-child th": {
                                        borderBottom: 0
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CoimexTooltip, {
                                        title: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "bg-[#8791A7]",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "text-white text-xs",
                                                children: [
                                                    " ",
                                                    row.ali
                                                ]
                                            })
                                        }),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                            component: "th",
                                            scope: "row",
                                            style: {
                                                paddingLeft: "44px"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                className: "list-outside",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: " md:w-auto list-disc text-[#38466D] capitalize text-base font-montserrat font-bold self-start",
                                                    children: row.name
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        align: "center",
                                        className: "w-[267px] text-[#38466D] text-sm font-montserrat text-left font-normal ",
                                        children: t("NewPrice.32")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableCell/* default */.Z, {
                                        align: "center",
                                        className: "text-[#38466D] text-base font-montserrat ",
                                        children: [
                                            typeof row.calories === "boolean" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ComSvg, {
                                                bol: row.calories
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ComTxt, {
                                                text: row.calories
                                            }),
                                            " ",
                                            row.name === t("NewPrice.20") ? type === "importer" ? t("NewPrice.60") : t("NewPrice.38") : row.name === t("NewPrice.21") ? type === "importer" ? t("NewPrice.61") : t("NewPrice.39") : row.name === t("NewPrice.22") ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    t("NewPrice.37"),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "flex flex-col items-center justify-center mt-2",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            className: "text-[#38466D] text-sm font-montserrat w-32 self-center",
                                                            children: [
                                                                "( ",
                                                                t("NewPrice.35"),
                                                                " )"
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }) : row.name === t("NewPrice.24") ? t("NewPrice.36") : null,
                                            row.name === t("NewPrice.23") && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    "",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "flex flex-col items-center justify-center mt-2",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "w-[163px] text-[#38466D] text-sm font-montserrat self-center",
                                                            children: "\xa0"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableCell/* default */.Z, {
                                        align: "center",
                                        className: "text-[#38466D] text-base font-montserrat ",
                                        children: [
                                            typeof row.fat === "boolean" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ComSvg, {
                                                bol: row.fat
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ComTxt, {
                                                text: row.fat
                                            }),
                                            " ",
                                            "",
                                            row.name === t("NewPrice.20") ? row.fat < 2 ? type === "importer" ? t("NewPrice.60") : t("NewPrice.38") : type === "importer" ? t("NewPrice.61") : t("NewPrice.59") : row.name === t("NewPrice.21") ? type === "importer" ? t("NewPrice.61") : t("NewPrice.39") : row.name === t("NewPrice.22") ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    t("NewPrice.37"),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "flex flex-col items-center justify-center mt-2",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            className: "text-[#38466D] text-sm font-montserrat w-32 self-center",
                                                            children: [
                                                                "( ",
                                                                t("NewPrice.35"),
                                                                " )"
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }) : row.name === t("NewPrice.24") ? t("NewPrice.36") : null,
                                            row.name === t("NewPrice.23") && row.fat && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex flex-col justify-center mt-2",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "w-[163px] text-[#38466D] text-sm font-montserrat self-center",
                                                    children: [
                                                        "( ",
                                                        t("NewPrice.40"),
                                                        " )"
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableCell/* default */.Z, {
                                        align: "center",
                                        className: "text-[#38466D] text-base font-montserrat text-center",
                                        children: [
                                            typeof row.carbs === "boolean" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ComSvg, {
                                                bol: row.carbs
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ComTxt, {
                                                text: row.carbs
                                            }),
                                            " ",
                                            row.name === t("NewPrice.20") ? row.carbs < 2 ? type === "importer" ? t("NewPrice.60") : t("NewPrice.38") : type === "importer" ? t("NewPrice.61") : t("NewPrice.59") : row.name === t("NewPrice.21") ? type === "importer" ? t("NewPrice.61") : t("NewPrice.39") : row.name === t("NewPrice.22") ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    t("NewPrice.37"),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "flex flex-col items-center justify-center mt-2",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            className: "text-[#38466D] text-sm font-montserrat w-32 self-center",
                                                            children: [
                                                                "( ",
                                                                t("NewPrice.35"),
                                                                " )"
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }) : row.name === t("NewPrice.24") ? t("NewPrice.36") : null,
                                            row.name === t("NewPrice.23") && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex flex-col items-center justify-center mt-2",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "w-[163px] text-[#38466D] text-sm font-montserrat self-center",
                                                    children: [
                                                        "( ",
                                                        t("NewPrice.40"),
                                                        " )"
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    row.protein && /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableCell/* default */.Z, {
                                        align: "center",
                                        className: "text-[#38466D] text-base font-montserrat",
                                        children: [
                                            typeof row.protein === "boolean" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ComSvg, {
                                                bol: row.protein
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ComTxt, {
                                                t: t,
                                                text: row.protein
                                            }),
                                            " ",
                                            row.name === t("NewPrice.20") ? row.protein < 2 ? type === "importer" ? t("NewPrice.60") : t("NewPrice.38") : type === "importer" ? t("NewPrice.61") : t("NewPrice.59") : row.name === t("NewPrice.21") ? type === "importer" ? t("NewPrice.61") : t("NewPrice.39") : row.name === t("NewPrice.22") ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    t("NewPrice.37"),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "flex flex-col items-center justify-center mt-2",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            className: "text-[#38466D] text-sm font-montserrat w-32 self-center",
                                                            children: [
                                                                "( ",
                                                                t("NewPrice.35"),
                                                                " )"
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }) : row.name === t("NewPrice.24") ? t("NewPrice.36") : null,
                                            row.name === t("NewPrice.23") && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-[#38466D] text-sm font-montserrat",
                                                children: t("NewPrice.40")
                                            })
                                        ]
                                    })
                                ]
                            }, row.name);
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHead/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                sx: {
                                    border: "none",
                                    width: "200px"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-[#38466D] md:w-auto text-xl font-MontserratBold whitespace-nowrap",
                                    children: t("Price.22")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                sx: {
                                    border: "none"
                                },
                                align: "center"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                sx: {
                                    border: "none"
                                },
                                align: "center"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                sx: {
                                    border: "none"
                                },
                                align: "center"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                sx: {
                                    border: "none"
                                },
                                align: "center"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableBody/* default */.Z, {
                    children: Support.map(function(row) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                            className: classes.tableRow,
                            style: {
                                height: "32px"
                            },
                            sx: {
                                "&:last-child td, &:last-child th": {
                                    border: 0
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CoimexTooltip, {
                                    title: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "bg-[#8791A7]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "text-white text-xs",
                                            children: [
                                                " ",
                                                row.name
                                            ]
                                        })
                                    }),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        component: "th",
                                        scope: "row",
                                        className: "px-8",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            className: "list-outside",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "w-64 md:w-auto list-disc text-[#38466D] text-base font-bold font-montserrat",
                                                children: row.name
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    align: "center",
                                    className: "w-[267px] text-[#38466D] text-sm font-montserrat text-left font-normal",
                                    children: t("NewPrice.32")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    align: "center",
                                    className: "text-[#38466D] text-base font-montserrat",
                                    children: typeof row.calories === "boolean" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ComSvg, {
                                        bol: row.calories
                                    }) : row.calories
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    align: "center",
                                    className: "text-[#38466D] text-base font-montserrat",
                                    children: typeof row.fat === "boolean" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ComSvg, {
                                        bol: row.fat
                                    }) : row.fat
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    align: "center",
                                    className: "text-[#38466D] text-base font-montserrat",
                                    children: typeof row.carbs === "boolean" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ComSvg, {
                                        bol: row.carbs
                                    }) : row.carbs
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    align: "center",
                                    className: "text-[#38466D] text-base font-montserrat",
                                    children: typeof row.protein === "boolean" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ComSvg, {
                                        bol: row.protein
                                    }) : row.protein
                                })
                            ]
                        }, row.name);
                    })
                })
            ]
        })
    });
};
var ComSvg = function(param) {
    var bol = param.bol;
    return bol ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgTck, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgNon, {});
};
var ComTxt = function(param) {
    var text = param.text;
    var bol = function bol() {
        if (typeof text === "string") {
            if (text.includes("week")) {
                return text.replace("week", t("Price.week"));
            } else if (text.includes("month")) {
                return text.replace("month", t("Price.month"));
            }
            return t("Price.".concat(text));
        } else {
            return text;
        }
    };
    var t = (0,esm/* useTranslation */.$G)().t;
    return isNaN(text) && !bol() ? t("Price.".concat(text)) : bol();
};
var SvgTck = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        className: "m-auto",
        width: "19",
        height: "12",
        viewBox: "0 0 19 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M18.3749 0.839371C18.534 0.95786 18.6295 1.12358 18.6405 1.3001C18.6514 1.47662 18.5768 1.64949 18.4332 1.7807L7.63258 11.6214L1.10176 6.48204C0.955117 6.35848 0.872417 6.1928 0.871109 6.01995C0.869802 5.84709 0.949988 5.68057 1.09475 5.55552C1.23952 5.43047 1.43754 5.35666 1.64705 5.34967C1.85656 5.34267 2.06117 5.40304 2.21773 5.51804L7.54686 9.71137L17.2339 0.886704C17.3052 0.821759 17.3913 0.769031 17.4873 0.731535C17.5834 0.694038 17.6874 0.672509 17.7935 0.668175C17.8996 0.663841 18.0057 0.676788 18.1058 0.706277C18.2058 0.735767 18.2978 0.781219 18.3766 0.840037L18.3749 0.839371Z",
            fill: "#38466D",
            stroke: "#38466D",
            strokeWidth: "0.5"
        })
    });
};
var SvgNon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        className: "m-auto",
        width: "13",
        height: "12",
        viewBox: "0 0 13 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M6.75294 6.00003L12.0528 10.3692M1.45312 10.3692L6.75294 6.00003L1.45312 10.3692ZM12.0528 1.63086L6.75193 6.00003L12.0528 1.63086ZM6.75193 6.00003L1.45312 1.63086L6.75193 6.00003Z",
            stroke: "#38466D",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
var CoimexTooltip = (0,styled/* default */.ZP)(function(_param) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)(Tooltip/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        classes: {
            popper: className
        }
    }));
})(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({}, "& .".concat(tooltipClasses/* default.tooltip */.Z.tooltip), {
        backgroundColor: "#8791A7",
        color: "#fff",
        maxWidth: 250,
        fontSize: theme.typography.pxToRem(12),
        border: "1px solid #dadde9"
    });
});

;// CONCATENATED MODULE: ./src/UI/components/Card/PricingCardMobile.js














function PricingCardMobile_createData(name, param, ali) {
    var _param = (0,_sliced_to_array/* default */.Z)(param, 4), calories = _param[0], fat = _param[1], carbs = _param[2], protein = _param[3];
    return {
        name: name,
        calories: calories,
        fat: fat,
        carbs: carbs,
        protein: protein,
        ali: ali
    };
}
var PricingCardMobile_useStyles = (0,makeStyles/* default */.Z)({
    table: {
        minWidth: 650
    },
    tableRow: {
        height: 20,
        paddingLeft: "32px",
        paddingRight: "32px"
    },
    tableCell: {
        padding: "0px 10px"
    }
});
var PricingCardMobile_StyledTableRow = (0,withStyles/* default */.Z)(function(theme) {
    return {
        root: {
            height: 20
        }
    };
})(TableRow/* default */.Z);
function CoimexPriceCardMobile(props) {
    var handleType = function handleType() {
        switch(type){
            case "importer":
                return rowsNewImporter;
            case "exporter":
                return rowsNewExporter;
            default:
                return rowsNewBoth;
        }
    };
    var handleSupport = function handleSupport() {
        switch(type){
            case "importer":
                return SupportDef;
            case "exporter":
                return Supportexport;
            default:
                return NewSupportBoth;
        }
    };
    var ref = (0,esm/* useTranslation */.$G)(), t = ref.t, i18n = ref.i18n;
    var router = (0,next_router.useRouter)();
    var classes = PricingCardMobile_useStyles();
    var ref1 = (0,react.useState)([]), rowsData = ref1[0], setRowsData = ref1[1];
    var type = router.query.package;
    var que = type === "importer" ? t("Price.10") : t("Price.11");
    var offer = type === "importer" ? t("Price.24") : t("Price.8");
    var productSupport = function(data) {
        return props.data.map(function(item, key) {
            return item.duration.type === props.value ? item === null || item === void 0 ? void 0 : item.quota.newSupport[data] : null;
        });
    };
    var ref2 = (0,react.useState)({}), openRows = ref2[0], setOpenRows = ref2[1];
    var toggleRow = function(rowName) {
        setOpenRows(function(prev) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), (0,_define_property/* default */.Z)({}, rowName, !prev[rowName]));
        });
    };
    var product = function(data) {
        return props.data.map(function(item, key) {
            return item.duration.type === props.value ? data === "posts" ? item === null || item === void 0 ? void 0 : item.quotaText.posts : item === null || item === void 0 ? void 0 : item.quota[data] : null;
        });
    };
    var rowsExporter = [
        PricingCardMobile_createData(t("Price.9"), product("categories").filter(function(item) {
            return item;
        }), t("Price.36")),
        PricingCardMobile_createData(offer, product("posts").filter(function(item) {
            return item;
        }), t("Price.37")),
        PricingCardMobile_createData(que, product("replyingProductPostsMessages").filter(function(item) {
            return item;
        }), t("Price.38")),
        PricingCardMobile_createData(t("Price.12"), product("regionsAndCountries").filter(function(item) {
            return item;
        }), t("Price.39")),
        PricingCardMobile_createData(t("Price.13"), product("instantOpportunityNotifications").filter(function(item) {
            return item;
        }), t("Price.40")),
        PricingCardMobile_createData(t("Price.14"), product("coiwallAccess").filter(function(item) {
            return item;
        }), t("Price.41")),
        PricingCardMobile_createData(t("Price.15"), product("nonMemberTrustVerification"), t("Price.42")), 
    ];
    var rowsImporter = [
        PricingCardMobile_createData(t("Price.9"), product("categories").filter(function(item) {
            return item;
        }), t("Price.28")),
        PricingCardMobile_createData(offer, product("posts").filter(function(item) {
            return item;
        }), t("Price.29")),
        //
        PricingCardMobile_createData(t("Price.26"), product("messagingProductPosts").filter(function(item) {
            return item;
        }), t("Price.30")),
        PricingCardMobile_createData(que, product("replyingProductPostsMessages").filter(function(item) {
            return item;
        }), t("Price.31")),
        PricingCardMobile_createData(t("Price.12"), product("regionsAndCountries").filter(function(item) {
            return item;
        }), t("Price.32")),
        PricingCardMobile_createData(t("Price.13"), product("instantOpportunityNotifications").filter(function(item) {
            return item;
        }), t("Price.33")),
        PricingCardMobile_createData(t("Price.14"), product("coiwallAccess").filter(function(item) {
            return item;
        }), t("Price.34")),
        PricingCardMobile_createData(t("Price.15"), product("nonMemberTrustVerification"), t("Price.35")), 
    ];
    var rowsBoth = [
        PricingCardMobile_createData(t("Price.9"), product("categories").filter(function(item) {
            return item;
        }), t("Price.43")),
        PricingCardMobile_createData(t("Price.26"), product("messagingProductPosts").filter(function(item) {
            return item;
        }), t("Price.46")),
        PricingCardMobile_createData(t("Price.24"), product("posts").filter(function(item) {
            return item;
        }), t("Price.45")),
        PricingCardMobile_createData(t("Price.8"), product("posts").filter(function(item) {
            return item;
        }), t("Price.43")),
        PricingCardMobile_createData(t("Price.10"), product("replyingProductPostsMessages").filter(function(item) {
            return item;
        }), t("Price.47")),
        PricingCardMobile_createData(t("Price.11"), product("replyingProductPostsMessages").filter(function(item) {
            return item;
        }), t("Price.44")),
        PricingCardMobile_createData(t("Price.12"), product("regionsAndCountries").filter(function(item) {
            return item;
        }), t("Price.48")),
        PricingCardMobile_createData(t("Price.13"), product("instantOpportunityNotifications").filter(function(item) {
            return item;
        }), t("Price.49")),
        PricingCardMobile_createData(t("Price.14"), product("coiwallAccess").filter(function(item) {
            return item;
        }), t("Price.50")),
        PricingCardMobile_createData(t("Price.15"), product("nonMemberTrustVerification").filter(function(item) {
            return item;
        }), t("Price.51")), 
    ];
    var rowsNewExporter = [
        PricingCardMobile_createData(t("NewPrice.20"), product("tradeGuarantee").filter(function(item) {
            return item;
        }), t("Price.43")),
        PricingCardMobile_createData(t("NewPrice.21"), product("productCategory").filter(function(item) {
            return item;
        }), t("Price.30")),
        PricingCardMobile_createData(t("NewPrice.22"), product("escrowSafePaymentFees").filter(function(item) {
            return item;
        }), t("Price.32")),
        PricingCardMobile_createData(t("NewPrice.23"), product("promptPayAssurance").filter(function(item) {
            return item != null;
        }), t("Price.43")),
        PricingCardMobile_createData(t("NewPrice.24"), product("systemUsage").filter(function(item) {
            return item;
        }), t("Price.33")), 
    ];
    var rowsNewImporter = [
        PricingCardMobile_createData(t("NewPrice.20"), product("tradeGuarantee").filter(function(item) {
            return item;
        }), t("Price.43")),
        PricingCardMobile_createData(t("NewPrice.21"), product("productCategory").filter(function(item) {
            return item;
        }), t("Price.30")),
        PricingCardMobile_createData(t("NewPrice.22"), product("escrowSafePaymentFees").filter(function(item) {
            return item;
        }), t("Price.32")),
        PricingCardMobile_createData(t("NewPrice.24"), product("systemUsage").filter(function(item) {
            return item;
        }), t("Price.33")), 
    ];
    var rowsNewBoth = [
        PricingCardMobile_createData(t("NewPrice.20"), product("tradeGuarantee").filter(function(item) {
            return item;
        }), t("Price.43")),
        PricingCardMobile_createData(t("NewPrice.21"), product("productCategory").filter(function(item) {
            return item;
        }), t("Price.46")),
        PricingCardMobile_createData(t("NewPrice.22"), product("escrowSafePaymentFees").filter(function(item) {
            return item;
        }), t("Price.45")),
        PricingCardMobile_createData(t("NewPrice.23"), product("promptPayAssurance").filter(function(item) {
            return item !== null;
        }), t("Price.43")),
        PricingCardMobile_createData(t("NewPrice.24"), product("systemUsage").filter(function(item) {
            return item;
        }), t("Price.47")), 
    ];
    var offerSupport = type === "importer" ? t("Price.25") : t("Price.18");
    var SupportDef = [
        PricingCardMobile_createData(t("NewPrice.26"), productSupport("matchmakingAndDealSupport").filter(function(item) {
            return item != null;
        })),
        PricingCardMobile_createData(t("NewPrice.27"), productSupport("nonMemberVerification").filter(function(item) {
            return item != null;
        })),
        PricingCardMobile_createData(t("NewPrice.28"), productSupport("opportunityAndPostSupport").filter(function(item) {
            return item != null;
        })),
        PricingCardMobile_createData(t("NewPrice.29"), productSupport("tradeShowMetingSupport").filter(function(item) {
            return item != null;
        })),
        PricingCardMobile_createData(t("NewPrice.30"), productSupport("marketingSupport").filter(function(item) {
            return item != null;
        })),
        PricingCardMobile_createData(t("NewPrice.31"), productSupport("strategicSupport").filter(function(item) {
            return item != null;
        })), 
    ];
    var Supportexport = [
        PricingCardMobile_createData(t("NewPrice.26"), productSupport("matchmakingAndDealSupport").filter(function(item) {
            return item != null;
        })),
        PricingCardMobile_createData(t("NewPrice.27"), productSupport("nonMemberVerification").filter(function(item) {
            return item != null;
        })),
        PricingCardMobile_createData(t("NewPrice.28"), productSupport("opportunityAndPostSupport").filter(function(item) {
            return item != null;
        })),
        PricingCardMobile_createData(t("NewPrice.29"), productSupport("tradeShowMetingSupport").filter(function(item) {
            return item != null;
        })),
        PricingCardMobile_createData(t("NewPrice.30"), productSupport("marketingSupport").filter(function(item) {
            return item != null;
        })),
        PricingCardMobile_createData(t("NewPrice.31"), productSupport("strategicSupport").filter(function(item) {
            return item != null;
        })), 
    ];
    var SupportBoth = [
        PricingCardMobile_createData(t("Price.16"), productSupport("technical").filter(function(item) {
            return item != null;
        })),
        PricingCardMobile_createData(t("Price.17"), productSupport("dealNegotiation").filter(function(item) {
            return item != null;
        })),
        PricingCardMobile_createData(t("Price.18"), productSupport("productPost").filter(function(item) {
            return item != null;
        })),
        PricingCardMobile_createData(t("Price.25"), productSupport("productPost").filter(function(item) {
            return item != null;
        })),
        PricingCardMobile_createData(t("Price.19"), productSupport("coiwall").filter(function(item) {
            return item != null;
        })),
        PricingCardMobile_createData(t("Price.20"), productSupport("marketing").filter(function(item) {
            return item != null;
        })),
        PricingCardMobile_createData(t("Price.21"), productSupport("strategicForeignTrade").filter(function(item) {
            return item != null;
        })), 
    ];
    var NewSupportBoth = [
        PricingCardMobile_createData(t("NewPrice.26"), productSupport("matchmakingAndDealSupport").filter(function(item) {
            return item != null;
        })),
        PricingCardMobile_createData(t("NewPrice.27"), productSupport("nonMemberVerification").filter(function(item) {
            return item != null;
        })),
        PricingCardMobile_createData(t("NewPrice.28"), productSupport("opportunityAndPostSupport").filter(function(item) {
            return item != null;
        })),
        PricingCardMobile_createData(t("NewPrice.29"), productSupport("tradeShowMetingSupport").filter(function(item) {
            return item != null;
        })),
        PricingCardMobile_createData(t("NewPrice.30"), productSupport("marketingSupport").filter(function(item) {
            return item != null;
        })),
        PricingCardMobile_createData(t("NewPrice.31"), productSupport("strategicSupport").filter(function(item) {
            return item != null;
        })), 
    ];
    var rows = handleType();
    var Support = handleSupport();
    var pricingTiers = [
        {
            label: "Freemium",
            key: "calories"
        },
        {
            label: "Starter",
            key: "fat"
        },
        {
            label: "Growth",
            key: "carbs"
        },
        {
            label: "Scale",
            key: "protein"
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: " bg-[#F4EFF4] md:hidden",
        children: [
            rows.map(function(row) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-full rounded-b-[8px] shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)] bg-[#FFFBFE] mb-[10px] ",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat(openRows[row.name] ? "" : "h-[64px] flex items-center", "  bg-[#D7DAE3] px-[19px]"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: " flex justify-between items-center w-full",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                            className: "text-[#38466D] text-xl font-bold ",
                                            children: row.name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            onClick: function() {
                                                return toggleRow(row.name);
                                            },
                                            children: openRows[row.name] ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapseUpSVG, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapseDownSVG, {})
                                        })
                                    ]
                                }),
                                openRows[row.name] && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-[#38466D] text-base font-normal mt-2",
                                    children: t("NewPrice.32")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "px-[19px] pt-[19px] pb-[30px]",
                            children: type === "importer" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "text-[#38466D] text-base font-montserrat",
                                                children: [
                                                    t("Price.Freemium"),
                                                    " "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "text-[#38466D] text-base font-montserrat ",
                                                children: [
                                                    typeof row.calories === "boolean" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingCardMobile_ComSvg, {
                                                        bol: row.calories
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingCardMobile_ComTxt, {
                                                        text: row.calories
                                                    }),
                                                    " ",
                                                    row.name === t("NewPrice.21") ? t("NewPrice.39") : row.name === t("NewPrice.22") ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: t("NewPrice.37")
                                                    }) : row.name === t("NewPrice.24") ? t("NewPrice.36") : null
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "text-[#38466D] text-base font-montserrat",
                                                children: [
                                                    t("Price.Starter"),
                                                    " "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "text-[#38466D] text-base font-montserrat ",
                                                children: [
                                                    typeof row.fat === "boolean" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingCardMobile_ComSvg, {
                                                        bol: row.fat
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingCardMobile_ComTxt, {
                                                        text: row.fat
                                                    }),
                                                    " ",
                                                    "",
                                                    row.name === t("NewPrice.21") ? t("NewPrice.39") : row.name === t("NewPrice.22") ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: t("NewPrice.37")
                                                    }) : row.name === t("NewPrice.24") ? t("NewPrice.36") : null
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "text-[#38466D] text-base font-montserrat",
                                                children: [
                                                    t("Price.Growth"),
                                                    " "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "text-[#38466D] text-base font-montserrat ",
                                                children: [
                                                    typeof row.carbs === "boolean" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingCardMobile_ComSvg, {
                                                        bol: row.carbs
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingCardMobile_ComTxt, {
                                                        text: row.carbs
                                                    }),
                                                    " ",
                                                    row.name === t("NewPrice.21") ? t("NewPrice.39") : row.name === t("NewPrice.22") ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: t("NewPrice.37")
                                                    }) : row.name === t("NewPrice.24") ? t("NewPrice.36") : null
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "text-[#38466D] text-base font-montserrat",
                                                children: [
                                                    t("Price.Scale"),
                                                    " "
                                                ]
                                            }),
                                            row.protein && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "text-[#38466D] text-base font-montserrat",
                                                children: [
                                                    typeof row.protein === "boolean" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingCardMobile_ComSvg, {
                                                        bol: row.protein
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingCardMobile_ComTxt, {
                                                        t: t,
                                                        text: row.protein
                                                    }),
                                                    " ",
                                                    row.name === t("NewPrice.21") ? t("NewPrice.39") : row.name === t("NewPrice.22") ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: t("NewPrice.37")
                                                    }) : row.name === t("NewPrice.24") ? t("NewPrice.36") : null,
                                                    row.name === t("NewPrice.23") && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-[#38466D] text-sm font-montserrat",
                                                        children: t("NewPrice.40")
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "text-[#38466D] text-base font-montserrat",
                                                children: [
                                                    t("Price.Starter"),
                                                    " "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "text-[#38466D] text-base font-montserrat ",
                                                children: [
                                                    typeof row.calories === "boolean" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingCardMobile_ComSvg, {
                                                        bol: row.calories
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingCardMobile_ComTxt, {
                                                        text: row.calories
                                                    }),
                                                    " ",
                                                    row.name === t("NewPrice.21") ? t("NewPrice.39") : row.name === t("NewPrice.22") ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: t("NewPrice.37")
                                                    }) : row.name === t("NewPrice.24") ? t("NewPrice.36") : null
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "text-[#38466D] text-base font-montserrat",
                                                children: [
                                                    t("Price.Growth"),
                                                    " "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "text-[#38466D] text-base font-montserrat ",
                                                children: [
                                                    typeof row.fat === "boolean" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingCardMobile_ComSvg, {
                                                        bol: row.fat
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingCardMobile_ComTxt, {
                                                        text: row.fat
                                                    }),
                                                    " ",
                                                    "",
                                                    row.name === t("NewPrice.21") ? t("NewPrice.39") : row.name === t("NewPrice.22") ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: t("NewPrice.37")
                                                    }) : row.name === t("NewPrice.24") ? t("NewPrice.36") : null
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "text-[#38466D] text-base font-montserrat",
                                                children: [
                                                    t("Price.Scale"),
                                                    " "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "text-[#38466D] text-base font-montserrat ",
                                                children: [
                                                    typeof row.carbs === "boolean" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingCardMobile_ComSvg, {
                                                        bol: row.carbs
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingCardMobile_ComTxt, {
                                                        text: row.carbs
                                                    }),
                                                    " ",
                                                    row.name === t("NewPrice.21") ? t("NewPrice.39") : row.name === t("NewPrice.22") ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: t("NewPrice.37")
                                                    }) : row.name === t("NewPrice.24") ? t("NewPrice.36") : null
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }, row.name);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-[#38466D] w-full text-xl font-MontserratBold whitespace-nowrap text-center",
                children: t("Price.22")
            }),
            Support.map(function(row) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-full rounded-b-md shadow-lg bg-[#FFFBFE] mb-[10px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat(openRows[row.name] ? "" : "pt-[19px] pb-[13px] flex items-center", "  bg-[#D7DAE3] px-[19px]"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: " flex justify-between items-center w-full",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                            className: "text-[#38466D] text-xl font-bold ",
                                            children: row.name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            onClick: function() {
                                                return toggleRow(row.name);
                                            },
                                            children: openRows[row.name] ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapseUpSVG, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapseDownSVG, {})
                                        })
                                    ]
                                }),
                                openRows[row.name] && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-[#38466D] text-base font-normal mt-2",
                                    children: t("NewPrice.32")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "px-[19px] pt-[19px] pb-[30px]",
                            children: type === "importer" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "text-[#38466D] text-base font-montserrat",
                                                children: [
                                                    "Freemium",
                                                    " "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-[#38466D] text-base font-montserrat flex items-center justify-between",
                                                children: typeof row.calories === "boolean" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingCardMobile_ComSvg, {
                                                    bol: row.calories
                                                }) : row.calories
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "text-[#38466D] text-base font-montserrat",
                                                children: [
                                                    "Starter",
                                                    " "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-[#38466D] text-base font-montserrat flex items-center justify-between",
                                                children: typeof row.fat === "boolean" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingCardMobile_ComSvg, {
                                                    bol: row.fat
                                                }) : row.fat
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "text-[#38466D] text-base font-montserrat",
                                                children: [
                                                    "Growth",
                                                    " "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-[#38466D] text-base font-montserrat flex items-center justify-between",
                                                children: typeof row.carbs === "boolean" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingCardMobile_ComSvg, {
                                                    bol: row.carbs
                                                }) : row.carbs
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "text-[#38466D] text-base font-montserrat",
                                                children: [
                                                    "Scale",
                                                    " "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-[#38466D] text-base font-montserrat flex items-center justify-between",
                                                children: typeof row.protein === "boolean" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingCardMobile_ComSvg, {
                                                    bol: row.protein
                                                }) : row.protein
                                            })
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "text-[#38466D] text-base font-montserrat",
                                                children: [
                                                    "Starter",
                                                    " "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-[#38466D] text-base font-montserrat flex items-center justify-between",
                                                children: typeof row.calories === "boolean" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingCardMobile_ComSvg, {
                                                    bol: row.calories
                                                }) : row.calories
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "text-[#38466D] text-base font-montserrat",
                                                children: [
                                                    "Growth",
                                                    " "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-[#38466D] text-base font-montserrat flex items-center justify-between",
                                                children: typeof row.fat === "boolean" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingCardMobile_ComSvg, {
                                                    bol: row.fat
                                                }) : row.fat
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "text-[#38466D] text-base font-montserrat",
                                                children: [
                                                    "Scale",
                                                    " "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-[#38466D] text-base font-montserrat flex items-center justify-between",
                                                children: typeof row.carbs === "boolean" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingCardMobile_ComSvg, {
                                                    bol: row.carbs
                                                }) : row.carbs
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }, row.name);
            })
        ]
    });
};
var PricingCardMobile_ComSvg = function(param) {
    var bol = param.bol;
    return bol ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingCardMobile_SvgTck, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingCardMobile_SvgNon, {});
};
var PricingCardMobile_ComTxt = function(param) {
    var text = param.text;
    var bol = function bol() {
        if (typeof text === "string") {
            if (text.includes("week")) {
                return text.replace("week", t("Price.week"));
            } else if (text.includes("month")) {
                return text.replace("month", t("Price.month"));
            }
            return t("Price.".concat(text));
        } else {
            return text;
        }
    };
    var t = (0,esm/* useTranslation */.$G)().t;
    return isNaN(text) && !bol() ? t("Price.".concat(text)) : bol();
};
var PricingCardMobile_SvgTck = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        className: "m-auto",
        width: "19",
        height: "12",
        viewBox: "0 0 19 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M18.3749 0.839371C18.534 0.95786 18.6295 1.12358 18.6405 1.3001C18.6514 1.47662 18.5768 1.64949 18.4332 1.7807L7.63258 11.6214L1.10176 6.48204C0.955117 6.35848 0.872417 6.1928 0.871109 6.01995C0.869802 5.84709 0.949988 5.68057 1.09475 5.55552C1.23952 5.43047 1.43754 5.35666 1.64705 5.34967C1.85656 5.34267 2.06117 5.40304 2.21773 5.51804L7.54686 9.71137L17.2339 0.886704C17.3052 0.821759 17.3913 0.769031 17.4873 0.731535C17.5834 0.694038 17.6874 0.672509 17.7935 0.668175C17.8996 0.663841 18.0057 0.676788 18.1058 0.706277C18.2058 0.735767 18.2978 0.781219 18.3766 0.840037L18.3749 0.839371Z",
            fill: "#38466D",
            stroke: "#38466D",
            strokeWidth: "0.5"
        })
    });
};
var PricingCardMobile_SvgNon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        className: "m-auto",
        width: "13",
        height: "12",
        viewBox: "0 0 13 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M6.75294 6.00003L12.0528 10.3692M1.45312 10.3692L6.75294 6.00003L1.45312 10.3692ZM12.0528 1.63086L6.75193 6.00003L12.0528 1.63086ZM6.75193 6.00003L1.45312 1.63086L6.75193 6.00003Z",
            stroke: "#38466D",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
var PricingCardMobile_CoimexTooltip = (0,styled/* default */.ZP)(function(_param) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)(Tooltip/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        classes: {
            popper: className
        }
    }));
})(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({}, "& .".concat(tooltipClasses/* default.tooltip */.Z.tooltip), {
        backgroundColor: "#8791A7",
        color: "#fff",
        maxWidth: 250,
        fontSize: theme.typography.pxToRem(12),
        border: "1px solid #dadde9"
    });
});
var CollapseUpSVG = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "8",
        viewBox: "0 0 14 8",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M13 7L7 1L1 7",
            stroke: "#38466D",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
var CollapseDownSVG = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "8",
        viewBox: "0 0 14 8",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            opacity: "0.7",
            d: "M1 1L7 7L13 1",
            stroke: "#38466D",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};

;// CONCATENATED MODULE: ./src/UI/components/Card/Card.js




// Utility function for combining class names
var cn = function() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++){
        classes[_key] = arguments[_key];
    }
    return classes.filter(Boolean).join(" ");
};
var Card = /*#__PURE__*/ react.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)("div", (0,_object_spread/* default */.Z)({
        ref: ref,
        className: cn("rounded-[8px] border bg-[#FFFBFE] text-gray-900 shadow-[0px_4px_4px_rgba(0,0,0,0.25)]", className)
    }, props));
});
Card.displayName = "Card";
var CardHeader = /*#__PURE__*/ react.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)("div", (0,_object_spread/* default */.Z)({
        ref: ref,
        className: cn("flex flex-col space-y-1.5 pt-6 pb-3 ", className)
    }, props));
});
CardHeader.displayName = "CardHeader";
var CardTitle = /*#__PURE__*/ react.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)("h3", (0,_object_spread/* default */.Z)({
        ref: ref,
        className: cn("text-2xl font-semibold leading-none tracking-tight", className)
    }, props));
});
CardTitle.displayName = "CardTitle";
var CardDescription = /*#__PURE__*/ react.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)("p", (0,_object_spread/* default */.Z)({
        ref: ref,
        className: cn("text-sm text-gray-500", className)
    }, props));
});
CardDescription.displayName = "CardDescription";
var CardContent = /*#__PURE__*/ react.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)("div", (0,_object_spread/* default */.Z)({
        ref: ref,
        className: cn(" pt-0", className)
    }, props));
});
CardContent.displayName = "CardContent";
var CardFooter = /*#__PURE__*/ react.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)("div", (0,_object_spread/* default */.Z)({
        ref: ref,
        className: cn("flex pt-0", className)
    }, props));
});
CardFooter.displayName = "CardFooter";


// EXTERNAL MODULE: ./node_modules/react-linkedin-insight/dist/linkedin-insight.js
var linkedin_insight = __webpack_require__(7234);
var linkedin_insight_default = /*#__PURE__*/__webpack_require__.n(linkedin_insight);
// EXTERNAL MODULE: ./src/pages/_document.js
var _document = __webpack_require__(172);
// EXTERNAL MODULE: ./node_modules/react-hotjar/index.js
var react_hotjar = __webpack_require__(5351);
;// CONCATENATED MODULE: ./src/pages/pricing/index.js






















var __N_SSG = true;
function Pricing(props) {
    var ref = (0,react.useState)(newPlansBoth_namespaceObject), plans = ref[0], setPlans = ref[1];
    var router = (0,next_router.useRouter)();
    var ref1 = (0,esm/* useTranslation */.$G)(), t = ref1.t, i18n = ref1.i18n;
    var ref2 = (0,react.useState)("1"), value = ref2[0], setValue = ref2[1];
    var handleChange = function(newValue) {
        setValue(newValue);
    };
    (0,react.useEffect)(function() {
        (0,_document/* initGA */._k)();
        (0,_document/* GApageView */.Yr)("price Page");
        linkedin_insight_default().init(_document/* linkedin_partner_id */.kC);
        if (react_hotjar.hotjar.initialized()) {
            react_hotjar.hotjar.stateChange("/pricing");
        }
    }, []);
    (0,react.useEffect)(function() {
        if (router.query.package === "importer") {
            setPlans(newPlansImpoter_namespaceObject);
        } else if (router.query.package === "exporter") {
            setPlans(newPlansExport_namespaceObject);
        } else {
            setPlans(newPlansBoth_namespaceObject);
        }
    }, [
        router.query.package
    ]);
    var reverseArray = (0,_to_consumable_array/* default */.Z)(plans.data).reverse();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: t("meta.7")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: t("meta.8")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: t("meta.8")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        itemProp: "description",
                        content: t("meta.8")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: t("meta.8")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: t("meta.8")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat(router.query.package === "importer" ? "px-4 md:px-24" : "px-4 md:px-24", " w-full bg-PrimaryA min-h-screen m-auto flex items-center flex-col"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "text-[30px] md:text-[52px] font-semibold font-Montserrat mt-16 text-fontColorB",
                        children: t("NewPrice.0")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: " text-base text-fontColorc w-full md:w-[642px] text-center font-montserrat",
                        children: t("NewPrice.57")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        rel: "noopener noreferrer",
                        className: "bg-fontColorB md:bg-[#FFFBFE] text-[#FFFBFE] md:text-fontColorB text-center font-MontserratSemiBold text-base h-[42px] rounded-[30px] mt-6 border border-fontColorB w-full md:w-[360px] border-b-[1px] border-b-[#38466D]",
                        style: {
                            fontWeight: 800,
                            fontStyle: "normal"
                        },
                        onClick: function() {
                            window.open("https://wa.me/905324479299", "_blank");
                        },
                        children: t("NewPrice.2")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: " w-full mx-auto py-16 space-y-16",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "grid md:gap-1 gap-4 w-full ".concat(router.query.package === "importer" ? "grid-cols-1 md:grid-cols-2 lg:grid-cols-4" : "grid-cols-1 md:grid-cols-3 "),
                                    children: reverseArray.filter(function(plan) {
                                        return plan.duration.type === "Annually";
                                    }).map(function(plan, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card, {
                                            className: "\n          flex flex-col justify-between bg-[#F4EFF4]\n          px-4 py-2 md:px-6 md:py-4 lg:".concat(router.query.package === "importer" ? "px-4" : "px-32", '\n          min-h-full md:shadow-lg shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)] "\n        '),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardHeader, {
                                                    className: "py-4 md:py-6 ".concat(router.query.package === "importer" ? "px-4 md:px-6" : "px-4 md:px-6 py-4 md:py-6"),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CardTitle, {
                                                            className: "text-fontColorB text-[28px] leading-6 mb-1 text-left font-MontserratSemiBold font-bold",
                                                            children: plan.type
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "space-y-1 text-left leading-6",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                    className: "text-base text-nowrap ",
                                                                    children: [
                                                                        plan.commonTag,
                                                                        " ",
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "font-semibold",
                                                                            children: plan.bestFor
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "text-base text-muted-foreground md:inline",
                                                                    children: plan.description
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                                    className: "ml-4 md:ml-6 mb-[18px] md:mb-0 w-full md:w-[237px]",
                                                    sx: {
                                                        borderColor: "#38466D"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent, {
                                                    className: "flex-grow px-4 md:px-6 py-4 md:py-6",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                        className: "space-y-3 md:space-y-4 flex flex-col items-start self-stretch",
                                                        children: plan.quota && Object.keys(plan.quota).length > 0 && Object.keys(plan.quota).map(function(key) {
                                                            var item = plan.quota[key];
                                                            var text = "";
                                                            var icon = null;
                                                            var isBold = false;
                                                            // Skip rendering if promptPayAssurance is false
                                                            if (key === "promptPayAssurance" && !item) {
                                                                return null;
                                                            }
                                                            if (key === "expansionFund" && item === false) {
                                                                return null;
                                                            }
                                                            switch(key){
                                                                case "tradeGuarantee":
                                                                    text = "".concat(item, " ").concat(router.query.package === "importer" ? item < 2 ? t("NewPrice.60") : t("NewPrice.61") : item < 2 ? t("NewPrice.38") : t("NewPrice.59"));
                                                                    icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgGroup, {
                                                                        className: "text-primary flex-shrink-0"
                                                                    });
                                                                    isBold = true;
                                                                    break;
                                                                case "productCategory":
                                                                    text = item;
                                                                    icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(pricing_SvgTck, {
                                                                        className: "flex-shrink-0"
                                                                    });
                                                                    break;
                                                                case "escrowSafePaymentFees":
                                                                    text = "".concat(item, " ").concat(t("NewPrice.42"));
                                                                    icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(pricing_SvgTck, {
                                                                        className: "flex-shrink-0"
                                                                    });
                                                                    break;
                                                                case "promptPayAssurance":
                                                                    text = t("NewPrice.43");
                                                                    icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(pricing_SvgTck, {
                                                                        className: "flex-shrink-0"
                                                                    });
                                                                    break;
                                                                case "expansionFund":
                                                                    text = t("NewPrice.66");
                                                                    icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(pricing_SvgTck, {
                                                                        className: "flex-shrink-0"
                                                                    });
                                                                    break;
                                                                default:
                                                                    return null;
                                                            }
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                className: "flex gap-3",
                                                                children: [
                                                                    icon,
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "flex-1",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                className: "text-base ".concat(isBold ? "font-bold" : ""),
                                                                                children: t("NewPrice.".concat(key === "tradeGuarantee" ? "20" : key === "productCategory" ? "21" : key === "escrowSafePaymentFees" ? "41" : key === "promptPayAssurance" ? "43" : key === "expansionFund" ? "67" : ""))
                                                                            }),
                                                                            " ",
                                                                            key !== "promptPayAssurance" && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                className: "text-base",
                                                                                children: text
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }, key);
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardFooter, {
                                                    className: "py-4 md:py-6 px-4 md:px-6 flex flex-col gap-4 md:gap-6 text-left",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "space-y-2",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                    className: "text-base text-fontColorB font-MontserratBold font-bold",
                                                                    children: [
                                                                        "$",
                                                                        plan.price,
                                                                        " ",
                                                                        t("NewPrice.33")
                                                                    ]
                                                                }),
                                                                plan.type !== "Freemium" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            className: "text-base text-[#000] leading-[20px] font-MontserratBold font-bold my-2",
                                                                            children: "Or"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "flex gap-2",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CoimexIcon, {}),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                    className: "leading-[20px] text-base font-bold text-fontColorB",
                                                                                    children: [
                                                                                        t("NewPrice.44"),
                                                                                        " ",
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                            className: "font-bold",
                                                                                            children: t("NewPrice.11")
                                                                                        }),
                                                                                        " ",
                                                                                        t("NewPrice.58")
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_CoimexButton, {
                                                            className: "bg-[#38466D] hover:bg-[#1f2a4b] text-[#FFFBFE] w-full",
                                                            size: "lg",
                                                            onClick: function() {
                                                                return router.push("https://app.coimex.co/#/auth/register/importer/".concat(plan.id));
                                                            },
                                                            children: plan.type === "Freemium" ? t("NewPrice.62") : t("NewPrice.12")
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, index);
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "bg-[#D7DAE3] p-4 sm:p-8 mt-4 rounded-[8px]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex items-start gap-2 mb-4",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgGroup, {
                                                    className: "h-5 w-5 text-black flex-shrink-0 mt-0.5"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "text-[20px] sm:text-[24px]",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "text-[#4A5568]",
                                                            children: t("NewPrice.52")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            className: "font-bold text-black",
                                                            children: [
                                                                " ",
                                                                t("NewPrice.20")
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            className: "text-[#4A5568]",
                                                            children: [
                                                                " ",
                                                                t("NewPrice.53")
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "text-base text-black leading-relaxed",
                                            children: [
                                                t("NewPrice.54"),
                                                " ",
                                                router.query.package === "importer" ? t("NewPrice.61") : t("NewPrice.59"),
                                                " ",
                                                t("NewPrice.65")
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-base text-black leading-relaxed mt-2",
                                            children: t("NewPrice.55")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "text-black",
                                            children: [
                                                " ",
                                                t("NewPrice.68")
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: " w-full m-auto flex items-center flex-col ",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "text-[30px] md:text-[52px] font-semibold font-Montserrat text-fontColorB",
                                children: t("NewPrice.56")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: " text-base text-fontColorc w-full md:w-[642px] text-center font-montserrat",
                                children: t("NewPrice.69")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat(router.query.package === "importer" ? "w-[100%] " : "w-[100%] ", " sm:bg-fontColorSurface mb-8  mt-8 md:my-[50px] rounded-2xl  sm:py-4 md:flex flex-col items-center "),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CoimexNewTable, {
                                onClick: function(e) {
                                    return router.push("https://app.coimex.co/#/auth/register/exporter/".concat(e.id));
                                },
                                data: (0,_to_consumable_array/* default */.Z)(plans.data).reverse(),
                                value: value === "1" ? "Annually" : "Biannually"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CoimexPriceCardMobile, {
                                onClick: function(e) {
                                    return router.push("https://app.coimex.co/#/auth/register/exporter/".concat(e.id));
                                },
                                data: (0,_to_consumable_array/* default */.Z)(plans.data).reverse(),
                                value: value === "1" ? "Annually" : "Biannually"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "sm:bg-fontColorSurface hidden bg-white md:my-[50px] w-[90%] rounded-2xl sm:px-10 sm:py-4 flex-col items-center ",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TabPlane, {
                            data: (0,_to_consumable_array/* default */.Z)(plans.data).reverse()
                        })
                    })
                ]
            })
        ]
    });
};
var pricing_SvgTck = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        className: "m-auto",
        width: "19",
        height: "12",
        viewBox: "0 0 19 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M18.3749 0.839371C18.534 0.95786 18.6295 1.12358 18.6405 1.3001C18.6514 1.47662 18.5768 1.64949 18.4332 1.7807L7.63258 11.6214L1.10176 6.48204C0.955117 6.35848 0.872417 6.1928 0.871109 6.01995C0.869802 5.84709 0.949988 5.68057 1.09475 5.55552C1.23952 5.43047 1.43754 5.35666 1.64705 5.34967C1.85656 5.34267 2.06117 5.40304 2.21773 5.51804L7.54686 9.71137L17.2339 0.886704C17.3052 0.821759 17.3913 0.769031 17.4873 0.731535C17.5834 0.694038 17.6874 0.672509 17.7935 0.668175C17.8996 0.663841 18.0057 0.676788 18.1058 0.706277C18.2058 0.735767 18.2978 0.781219 18.3766 0.840037L18.3749 0.839371Z",
            fill: "#38466D",
            stroke: "#38466D",
            strokeWidth: "0.5"
        })
    });
};
var pricing_SvgNon = function() {
    return /*#__PURE__*/ _jsx("svg", {
        className: "m-auto",
        width: "13",
        height: "12",
        viewBox: "0 0 13 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M6.75294 6.00003L12.0528 10.3692M1.45312 10.3692L6.75294 6.00003L1.45312 10.3692ZM12.0528 1.63086L6.75193 6.00003L12.0528 1.63086ZM6.75193 6.00003L1.45312 1.63086L6.75193 6.00003Z",
            stroke: "#38466D",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
var SvgGroup = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "21",
        height: "26",
        viewBox: "0 0 22 26",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.0013 1.00012L11.3946 0.0801156C11.2703 0.0269322 11.1365 -0.000488281 11.0013 -0.000488281C10.8661 -0.000488281 10.7323 0.0269322 10.608 0.0801156L11.0013 1.00012ZM11.0013 25.0001L10.5053 25.8681C10.6564 25.9544 10.8273 25.9998 11.0013 25.9998C11.1753 25.9998 11.3462 25.9544 11.4973 25.8681L11.0013 25.0001ZM10.6066 0.0814492L2.08397 3.73345L2.86797 5.57345L11.3933 1.92012L10.6066 0.0814492ZM0.667969 5.87878V15.0254H2.66797V5.87878H0.667969ZM5.20264 22.8388L10.5053 25.8681L11.4973 24.1321L6.19464 21.1014L5.20264 22.8388ZM11.4973 25.8681L16.8 22.8388L15.808 21.1014L10.5053 24.1321L11.4973 25.8681ZM21.3346 15.0241V5.88012H19.3346V15.0268L21.3346 15.0241ZM19.9213 3.73478L11.3946 0.0814492L10.608 1.91878L19.1333 5.57345L19.9213 3.73478ZM21.3346 5.88012C21.3346 4.94678 20.7786 4.10278 19.9213 3.73478L19.1333 5.57345C19.1932 5.59927 19.2442 5.64209 19.2799 5.69659C19.3157 5.7511 19.3347 5.81491 19.3346 5.88012H21.3346ZM16.8 22.8388C18.1774 22.0517 19.3223 20.9144 20.1186 19.5423C20.915 18.1702 21.3345 16.6119 21.3346 15.0254H19.3346C19.3344 16.2592 19.0081 17.4709 18.3887 18.5379C17.7694 19.6049 16.8791 20.4893 15.808 21.1014L16.8 22.8388ZM0.667969 15.0254C0.668111 16.6119 1.08761 18.1702 1.88396 19.5423C2.6803 20.9144 3.8252 22.0517 5.20264 22.8388L6.19464 21.1014C5.12331 20.4892 4.23286 19.6046 3.61353 18.5373C2.9942 17.4701 2.668 16.2581 2.66797 15.0241L0.667969 15.0254ZM2.0813 3.73345C1.66184 3.91341 1.30438 4.21245 1.05317 4.59354C0.801955 4.97462 0.668028 5.42235 0.667969 5.87878H2.66797C2.66797 5.74545 2.74797 5.62412 2.87064 5.57078L2.0813 3.73345Z",
                fill: "#38466D"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15 10.3335L9.66667 15.6668L7 13.0002",
                stroke: "#38466D",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
var CoimexIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "23",
        height: "24",
        viewBox: "0 0 23 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.16888 23.3069C5.16888 23.3069 4.01282 22.7457 3.54703 22.5381C3.07563 22.3248 2.64913 21.7468 2.57056 20.9836L0.0171318 3.55292C0.0171318 3.55292 -0.319584 1.47089 1.99253 1.90862L18.5309 8.42407L16.4881 9.96173L3.23838 4.78193C3.23838 4.78193 2.23945 4.45082 2.4471 5.51148C2.4471 5.51148 4.92757 22.9646 5.16888 23.3069Z",
                fill: "#38466D"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M22.6763 9.08067C22.6763 9.08067 22.7605 10.3602 22.811 10.8709C22.8615 11.3816 22.5697 12.0382 21.9524 12.4871L7.88331 23.6099C7.88331 23.6099 6.72726 24.5415 5.9023 23.5258C5.47018 22.9926 5.44774 22.5156 5.35795 21.8815L5.24571 21.1295L2.93359 5.11865L5.27938 6.1288L7.35018 20.2035C7.35018 20.2035 7.55782 21.2361 8.37716 20.529C8.37716 20.529 22.4968 9.45667 22.6763 9.08067Z",
                fill: "#38466D"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M1.37109 1.27997C1.37109 1.27997 2.43736 0.567256 2.85264 0.264212C3.26231 -0.0332202 3.98064 -0.111787 4.68213 0.196869L21.4001 6.7516C21.4001 6.7516 22.5337 7.18933 22.4046 8.17703C22.298 8.98515 21.6638 9.41726 21.0802 9.87183L7.87532 20.2202L7.48248 17.7061L18.7176 8.92341C18.7176 8.92341 19.5088 8.22754 18.4875 7.8796C18.4875 7.8796 1.78638 1.2463 1.37109 1.27997Z",
                fill: "#38466D"
            })
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [39,806,985,774,888,179], function() { return __webpack_exec__(609); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);